/* tslint:disable */
/* eslint-disable */
/**
 * Stair Crusher Club API Specification
 * ## 계단정복지도 서비스의 서버 - 클라이언트 통신을 위한 API 명세.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from './base';
/**
 *
 * @export
 * @enum {string}
 */
export const AccessibilityReportReason = {
    InaccurateInfo: 'INACCURATE_INFO',
    Closed: 'CLOSED',
    BadUser: 'BAD_USER'
};
/**
 * 접근성 데이터 출처
 * @export
 * @enum {string}
 */
export const AccessibilitySourceDto = {
    SmartSeoulMap: 'SMART_SEOUL_MAP',
    MoisPublicToilet: 'MOIS_PUBLIC_TOILET'
};
/**
 * AI 요약 한 줄의 출처 탭.
 * @export
 * @enum {string}
 */
export const AiSummarySourceTabDto = {
    Accessibility: 'ACCESSIBILITY',
    Review: 'REVIEW'
};
export const ApiErrorResponseCodeEnum = {
    INTERNAL_FAILURE: '-999999',
    INVALID_AUTHENTICATION: '1',
    INVALID_NICKNAME: '2',
    INVALID_EMAIL: '3',
    INVALID_ARGUMENTS: '4',
    INVALID_PASSCODE: '10',
    ALREADY_JOINED: '11',
    CHALLENGE_NOT_OPENED: '12',
    CHALLENGE_CLOSED: '13',
    INVALID_BIRTH_YEAR: '14',
    B2B_INFO_REQUIRED: '15',
    PHONE_NUMBER_VERIFICATION_FAILED: '16',
    CHALLENGE_FULL: '20'
};
export const BbucleRoadAccessibilityDtoBbucleRoadTypeEnum = {
    BaseballStadium: 'BASEBALL_STADIUM',
    ConcertHall: 'CONCERT_HALL'
};
/**
 *
 * @export
 * @enum {string}
 */
export const BbucleRoadMarkerTypeDto = {
    Restaurant: 'RESTAURANT',
    Cafe: 'CAFE',
    AccessibleToilet: 'ACCESSIBLE_TOILET',
    AccessibilityInfo: 'ACCESSIBILITY_INFO',
    TicketBooth: 'TICKET_BOOTH',
    Entrance: 'ENTRANCE',
    Elevator: 'ELEVATOR',
    SubwayExit: 'SUBWAY_EXIT',
    BusStop: 'BUS_STOP',
    Parking: 'PARKING',
    Custom: 'CUSTOM'
};
/**
 *
 * @export
 * @enum {string}
 */
export const BbucleRoadRouteIconTypeDto = {
    Subway: 'SUBWAY',
    Taxi: 'TAXI',
    Car: 'CAR',
    Bus: 'BUS'
};
/**
 *
 * @export
 * @enum {string}
 */
export const BbucleRoadSectionTypeDto = {
    MapOverview: 'MAP_OVERVIEW',
    Traffic: 'TRAFFIC',
    Ticketing: 'TICKETING',
    WheelchairView: 'WHEELCHAIR_VIEW',
    NearbyRestaurants: 'NEARBY_RESTAURANTS',
    NearbyCafes: 'NEARBY_CAFES'
};
/**
 * 건물 입구 문의 방향 (도로쪽, 주차장쪽, 기타)
 * @export
 * @enum {string}
 */
export const BuildingDoorDirectionTypeDto = {
    RoadDirection: 'ROAD_DIRECTION',
    ParkingDirection: 'PARKING_DIRECTION',
    Etc: 'ETC'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ChallengeB2bFormAvailableFieldNameTypeDto = {
    ParticipantName: 'participantName',
    CompanyName: 'companyName',
    OrganizationName: 'organizationName',
    EmployeeIdentificationNumber: 'employeeIdentificationNumber'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ChallengeFormFieldTypeDto = {
    Text: 'TEXT',
    Select: 'SELECT'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ChallengeQuestCompleteStampTypeDto = {
    Flag: 'FLAG',
    Cafe: 'CAFE',
    ThumbsUp: 'THUMBS_UP',
    Potion: 'POTION',
    Restaurant: 'RESTAURANT',
    Review: 'REVIEW'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ChallengeStatusDto = {
    InProgress: 'InProgress',
    Upcoming: 'Upcoming',
    Closed: 'Closed'
};
/**
 * 폐업/이전 신고 시 세부 유형
 * @export
 * @enum {string}
 */
export const ClosedSubTypeDto = {
    PermanentlyClosed: 'PERMANENTLY_CLOSED',
    ReplacedByOther: 'REPLACED_BY_OTHER',
    Other: 'OTHER'
};
/**
 *
 * @export
 * @enum {string}
 */
export const CrusherActivityHistorySummaryTypeDto = {
    Crew: 'CREW',
    ConquerActivityGuest: 'CONQUER_ACTIVITY_GUEST'
};
/**
 *
 * @export
 * @enum {string}
 */
export const CrusherClubCrewTypeDto = {
    EditorCrew: 'EDITOR_CREW',
    ConquerCrew: 'CONQUER_CREW'
};
/**
 *
 * @export
 * @enum {string}
 */
export const CrusherClubQuestCompleteStampTypeDto = {
    StartingDay: 'STARTING_DAY',
    ShortReview1: 'SHORT_REVIEW_1',
    ShortReview2: 'SHORT_REVIEW_2',
    ShortReview3: 'SHORT_REVIEW_3',
    ShortReview4: 'SHORT_REVIEW_4',
    ShortReview5: 'SHORT_REVIEW_5',
    ShortReview6: 'SHORT_REVIEW_6',
    ShortReview7: 'SHORT_REVIEW_7',
    ShortReview8: 'SHORT_REVIEW_8',
    LongReview1: 'LONG_REVIEW_1',
    LongReview2: 'LONG_REVIEW_2',
    LongReviewCoreMission: 'LONG_REVIEW_CORE_MISSION',
    AppUsageReview: 'APP_USAGE_REVIEW',
    ConquerQuest: 'CONQUER_QUEST',
    WarmingUpConquer: 'WARMING_UP_CONQUER',
    Conquer1: 'CONQUER_1',
    Conquer2: 'CONQUER_2',
    Conquer3: 'CONQUER_3',
    Conquer4: 'CONQUER_4',
    Conquer5: 'CONQUER_5',
    Conquer6: 'CONQUER_6',
    ConquerCoreMission: 'CONQUER_CORE_MISSION',
    EditorTime1: 'EDITOR_TIME_1',
    EditorTime2: 'EDITOR_TIME_2',
    TeamOuting: 'TEAM_OUTING',
    DailyLifeQuest: 'DAILY_LIFE_QUEST',
    SavedPlaceList: 'SAVED_PLACE_LIST'
};
/**
 *
 * @export
 * @enum {string}
 */
export const CrusherClubQuestTypeDto = {
    StartingDay: 'STARTING_DAY',
    ShortReview: 'SHORT_REVIEW',
    LongReview: 'LONG_REVIEW',
    AppUsageReview: 'APP_USAGE_REVIEW',
    ConquerQuest: 'CONQUER_QUEST',
    WarmingUpConquer: 'WARMING_UP_CONQUER',
    Conquer: 'CONQUER',
    DailyLifeQuest: 'DAILY_LIFE_QUEST',
    SavedPlaceList: 'SAVED_PLACE_LIST'
};
/**
 *
 * @export
 * @enum {string}
 */
export const DayOfWeek = {
    Sunday: 'SUNDAY',
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY'
};
/**
 * 엘리베이터 교정 대상
 * @export
 * @enum {string}
 */
export const ElevatorCorrectionTargetDto = {
    Pa: 'PA',
    Ba: 'BA'
};
/**
 *
 * @export
 * @enum {string}
 */
export const EntranceDoorType = {
    None: 'None',
    Hinged: 'Hinged',
    Sliding: 'Sliding',
    Revolving: 'Revolving',
    Automatic: 'Automatic',
    Etc: 'ETC'
};
/**
 * 층간 이동 방법
 * @export
 * @enum {string}
 */
export const FloorMovingMethodTypeDto = {
    PlaceElevator: 'PLACE_ELEVATOR',
    PlaceStairs: 'PLACE_STAIRS',
    PlaceEscalator: 'PLACE_ESCALATOR',
    BuildingElevator: 'BUILDING_ELEVATOR',
    BuildingStairs: 'BUILDING_STAIRS',
    BuildingEscalator: 'BUILDING_ESCALATOR',
    Unknown: 'UNKNOWN'
};
export const GetClientVersionStatusResponseDtoStatusEnum = {
    Stable: 'STABLE',
    UpgradeNeeded: 'UPGRADE_NEEDED',
    UpgradeRecommended: 'UPGRADE_RECOMMENDED'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ImageUploadPurpose = {
    Accessibility: 'ACCESSIBILITY',
    PlaceReview: 'PLACE_REVIEW',
    ToiletReview: 'TOILET_REVIEW'
};
/**
 * 틀린 정보 신고 시 구체적으로 어떤 항목이 틀렸는지
 * @export
 * @enum {string}
 */
export const InaccurateInfoCategoryDto = {
    PlaceEntrance: 'PLACE_ENTRANCE',
    BuildingEntrance: 'BUILDING_ENTRANCE',
    Floor: 'FLOOR',
    DoorType: 'DOOR_TYPE',
    Elevator: 'ELEVATOR',
    AccessLevel: 'ACCESS_LEVEL',
    Photo: 'PHOTO',
    Other: 'OTHER'
};
/**
 * 검수 상태 - PASS: 접근성 정보 승인 - FAIL: 접근성 정보 삭제 필요 - MODIFY: 수정 필요
 * @export
 * @enum {string}
 */
export const InspectionStatusDto = {
    Pass: 'PASS',
    Fail: 'FAIL',
    Modify: 'MODIFY'
};
/**
 * 붐따 사유.
 * @export
 * @enum {string}
 */
export const PlaceAiSummaryDownvoteReasonDto = {
    InaccurateInfo: 'INACCURATE_INFO',
    TooLong: 'TOO_LONG',
    Other: 'OTHER'
};
/**
 * AI 요약에 대한 붐업/붐따 투표. CANCEL 은 이미 남긴 붐업/붐따를 취소한 것으로, 서버는 해당 피드백을 삭제해 남기지 않은 상태로 되돌린다 (재진입 시 버튼이 다시 노출된다).
 * @export
 * @enum {string}
 */
export const PlaceAiSummaryVoteDto = {
    Up: 'UP',
    Down: 'DOWN',
    Cancel: 'CANCEL'
};
/**
 *
 * @export
 * @enum {string}
 */
export const PlaceCategoryDto = {
    Restaurant: 'RESTAURANT',
    Cafe: 'CAFE',
    Accomodation: 'ACCOMODATION',
    Market: 'MARKET',
    ConvenienceStore: 'CONVENIENCE_STORE',
    Kindergarten: 'KINDERGARTEN',
    School: 'SCHOOL',
    Academy: 'ACADEMY',
    ParkingLot: 'PARKING_LOT',
    GasStation: 'GAS_STATION',
    SubwayStation: 'SUBWAY_STATION',
    Bank: 'BANK',
    CulturalFacilities: 'CULTURAL_FACILITIES',
    Agency: 'AGENCY',
    PublicOffice: 'PUBLIC_OFFICE',
    Attraction: 'ATTRACTION',
    Hospital: 'HOSPITAL',
    Pharmacy: 'PHARMACY'
};
/**
 * 장소 입구 문이 건물 외부로 향하는지 내부로 향하는지
 * @export
 * @enum {string}
 */
export const PlaceDoorDirectionTypeDto = {
    OutsideBuilding: 'OUTSIDE_BUILDING',
    InsideBuilding: 'INSIDE_BUILDING'
};
/**
 * 저장 리스트 접근 제어. Google Drive 파일 공유 모델을 모방한다. - PRIVATE: 본인만 접근 가능 (예: 개인 저장 장소) - PUBLIC: 모든 사용자에게 공개 - LINK_ONLY: 튜토리얼 메인 미션을 모두 완료한 사용자에게만 노출
 * @export
 * @enum {string}
 */
export const PlaceListAccessControlDto = {
    Private: 'PRIVATE',
    Public: 'PUBLIC',
    LinkOnly: 'LINK_ONLY'
};
/**
 * 저장 리스트 타입
 * @export
 * @enum {string}
 */
export const PlaceListTypeDto = {
    MyPlaces: 'MY_PLACES',
    Normal: 'NORMAL'
};
/**
 * 장소 검색 추천 칩 탭 시 랜딩(navigation) 타입
 * @export
 * @enum {string}
 */
export const PlaceSearchRecommendationNavigationTypeDto = {
    PlaceList: 'PLACE_LIST'
};
/**
 * 장소 검색 추천의 discovery 타입 — 추천이 어떻게 만들어지고 매칭됐는지를 나타낸다. 칩의 비주얼 디자인을 결정한다. 탭 시 랜딩은 navigationType이 결정(직교한 별도 차원).
 * @export
 * @enum {string}
 */
export const PlaceSearchRecommendationTypeDto = {
    RegionBased: 'REGION_BASED'
};
/**
 * /searchPlaces 응답의 결과 종류 판별자.
 * @export
 * @enum {string}
 */
export const PlaceSearchResultModeDto = {
    Place: 'PLACE',
    AccessibleToilet: 'ACCESSIBLE_TOILET'
};
export const PlaceSpecialAccessibilityDtoAccessibilityTypeEnum = {
    BbucleRoad: 'BBUCLE_ROAD'
};
/**
 * 장소 태그 타입
 * @export
 * @enum {string}
 */
export const PlaceTagTypeDto = {
    PlaceList: 'PLACE_LIST'
};
/**
 *
 * @export
 * @enum {string}
 */
export const RecommendedMobilityTypeDto = {
    ManualWheelchair: 'MANUAL_WHEELCHAIR',
    ElectricWheelchair: 'ELECTRIC_WHEELCHAIR',
    Elderly: 'ELDERLY',
    Stroller: 'STROLLER',
    NotSure: 'NOT_SURE',
    None: 'NONE'
};
export const RegisterHumanInspectionResultRequestDtoAccessibilityTypeEnum = {
    PlaceAccessibility: 'PLACE_ACCESSIBILITY',
    BuildingAccessibility: 'BUILDING_ACCESSIBILITY'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ReportTargetTypeDto = {
    PlaceAccessibility: 'PLACE_ACCESSIBILITY',
    BuildingAccessibility: 'BUILDING_ACCESSIBILITY',
    PlaceReview: 'PLACE_REVIEW',
    ToiletReview: 'TOILET_REVIEW'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ResolveSharedPlaceLinkResultStatusDto = {
    Matched: 'MATCHED',
    Ambiguous: 'AMBIGUOUS',
    NotFound: 'NOT_FOUND'
};
/**
 * 저장 가능한 컨텐츠 타입. 초기에는 WEB_PAGE 하나만 지원하지만 향후 확장 가능.
 * @export
 * @enum {string}
 */
export const SccContentTypeDto = {
    WebPage: 'WEB_PAGE'
};
/**
 *
 * @export
 * @enum {string}
 */
export const SearchPlaceSortDto = {
    Accuracy: 'ACCURACY',
    Distance: 'DISTANCE',
    AccessibilityScore: 'ACCESSIBILITY_SCORE'
};
/**
 *
 * @export
 * @enum {string}
 */
export const SharedPlaceLinkVendorDto = {
    Kakao: 'KAKAO',
    Naver: 'NAVER',
    Google: 'GOOGLE',
    Tmap: 'TMAP',
    Unknown: 'UNKNOWN'
};
/**
 * 내부 공간이 여유롭나요?
 * @export
 * @enum {string}
 */
export const SpaciousTypeDto = {
    Wide: 'WIDE',
    Enough: 'ENOUGH',
    Limited: 'LIMITED',
    Tight: 'TIGHT'
};
/**
 *
 * @export
 * @enum {string}
 */
export const StairHeightLevel = {
    HalfThumb: 'HALF_THUMB',
    Thumb: 'THUMB',
    OverThumb: 'OVER_THUMB'
};
/**
 *
 * @export
 * @enum {string}
 */
export const StairInfo = {
    Undefined: 'UNDEFINED',
    None: 'NONE',
    One: 'ONE',
    TwoToFive: 'TWO_TO_FIVE',
    OverSix: 'OVER_SIX'
};
/**
 *
 * @export
 * @enum {string}
 */
export const ToiletLocationTypeDto = {
    Place: 'PLACE',
    Building: 'BUILDING',
    None: 'NONE',
    Etc: 'ETC'
};
/**
 * 윌리의 외출 NUX 튜토리얼 미션 종류. HIDDEN_APP_SURVEY가 히든 미션(앱 사용 후기 설문)이며, 나머지가 메인 미션이다. 이 enum 선언 순서는 미션 순서를 의미하지 않는다. 미션 순서는 UserTutorialProgressDto.missions 배열 순서를 따르며, 사용자의 가입 시점에 따라 서로 다른 미션 셋(v1/v2)이 내려온다. 클라이언트는 순서를 하드코딩하지 않는다.
 * @export
 * @enum {string}
 */
export const TutorialMissionTypeDto = {
    ViewTutorialImages: 'VIEW_TUTORIAL_IMAGES',
    RegisterInterestedRegionsAndThemes: 'REGISTER_INTERESTED_REGIONS_AND_THEMES',
    SavePlaceList: 'SAVE_PLACE_LIST',
    UpvoteAccessibility: 'UPVOTE_ACCESSIBILITY',
    HiddenAppSurvey: 'HIDDEN_APP_SURVEY'
};
/**
 *
 * @export
 * @enum {string}
 */
export const UpvoteTargetTypeDto = {
    Place: 'PLACE',
    PlaceAccessibility: 'PLACE_ACCESSIBILITY',
    BuildingAccessibility: 'BUILDING_ACCESSIBILITY',
    PlaceReview: 'PLACE_REVIEW',
    ToiletReview: 'TOILET_REVIEW',
    BbucleRoad: 'BBUCLE_ROAD',
    Article: 'ARTICLE'
};
/**
 * 사용자의 관심 테마. 윌리의 외출 NUX 튜토리얼 첫 번째 메인 미션에서 선택한다. Figma 1427-8980 화면 기준 8개 항목.
 * @export
 * @enum {string}
 */
export const UserInterestedThemeDto = {
    WheelchairReview: 'WHEELCHAIR_REVIEW',
    MediaHotspot: 'MEDIA_HOTSPOT',
    FoodCafeTour: 'FOOD_CAFE_TOUR',
    EmotionalView: 'EMOTIONAL_VIEW',
    Sports: 'SPORTS',
    Culture: 'CULTURE',
    Travel: 'TRAVEL',
    Nature: 'NATURE'
};
/**
 *
 * @export
 * @enum {string}
 */
export const UserMobilityToolDto = {
    ManualWheelchair: 'MANUAL_WHEELCHAIR',
    ElectricWheelchair: 'ELECTRIC_WHEELCHAIR',
    ManualAndElectricWheelchair: 'MANUAL_AND_ELECTRIC_WHEELCHAIR',
    Stroller: 'STROLLER',
    ProstheticFoot: 'PROSTHETIC_FOOT',
    WalkingAssistanceDevice: 'WALKING_ASSISTANCE_DEVICE',
    Cluch: 'CLUCH',
    None: 'NONE',
    FriendOfWheelchairUser: 'FRIEND_OF_WHEELCHAIR_USER',
    Scooter: 'SCOOTER',
    Cane: 'CANE',
    WalkerAndWalkingCart: 'WALKER_AND_WALKING_CART',
    Crutch: 'CRUTCH',
    FriendOfWalkingAidUser: 'FRIEND_OF_WALKING_AID_USER',
    WalkingDifficulty: 'WALKING_DIFFICULTY'
};
export const VendorPlaceIdDtoVendorTypeEnum = {
    Kakao: 'KAKAO',
    Naver: 'NAVER',
    Google: 'GOOGLE',
    Tmap: 'TMAP'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary 건물에 대해 \'이 정보가 도움이 돼요\'를 취소한다.
         * @param {CancelBuildingAccessibilityUpvoteRequestDto} cancelBuildingAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelBuildingAccessibilityUpvotePost: (cancelBuildingAccessibilityUpvoteRequestDto_1, ...args_1) => __awaiter(this, [cancelBuildingAccessibilityUpvoteRequestDto_1, ...args_1], void 0, function* (cancelBuildingAccessibilityUpvoteRequestDto, options = {}) {
            // verify required parameter 'cancelBuildingAccessibilityUpvoteRequestDto' is not null or undefined
            assertParamExists('cancelBuildingAccessibilityUpvotePost', 'cancelBuildingAccessibilityUpvoteRequestDto', cancelBuildingAccessibilityUpvoteRequestDto);
            const localVarPath = `/cancelBuildingAccessibilityUpvote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cancelBuildingAccessibilityUpvoteRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 장소에 대해 \'이 정보가 도움이 돼요\'를 취소한다.
         * @param {CancelPlaceAccessibilityUpvoteRequestDto} cancelPlaceAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelPlaceAccessibilityUpvotePost: (cancelPlaceAccessibilityUpvoteRequestDto_1, ...args_1) => __awaiter(this, [cancelPlaceAccessibilityUpvoteRequestDto_1, ...args_1], void 0, function* (cancelPlaceAccessibilityUpvoteRequestDto, options = {}) {
            // verify required parameter 'cancelPlaceAccessibilityUpvoteRequestDto' is not null or undefined
            assertParamExists('cancelPlaceAccessibilityUpvotePost', 'cancelPlaceAccessibilityUpvoteRequestDto', cancelPlaceAccessibilityUpvoteRequestDto);
            const localVarPath = `/cancelPlaceAccessibilityUpvote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cancelPlaceAccessibilityUpvoteRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary \'도움이 돼요\'를 취소한다.
         * @param {CancelUpvoteRequestDto} cancelUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelUpvotePost: (cancelUpvoteRequestDto_1, ...args_1) => __awaiter(this, [cancelUpvoteRequestDto_1, ...args_1], void 0, function* (cancelUpvoteRequestDto, options = {}) {
            // verify required parameter 'cancelUpvoteRequestDto' is not null or undefined
            assertParamExists('cancelUpvotePost', 'cancelUpvoteRequestDto', cancelUpvoteRequestDto);
            const localVarPath = `/cancelUpvote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(cancelUpvoteRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 크러셔 클럽 퀘스트에 체크인한다.
         * @param {CheckInToClubQuestRequestDto} checkInToClubQuestRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInToClubQuestPost: (checkInToClubQuestRequestDto_1, ...args_1) => __awaiter(this, [checkInToClubQuestRequestDto_1, ...args_1], void 0, function* (checkInToClubQuestRequestDto, options = {}) {
            // verify required parameter 'checkInToClubQuestRequestDto' is not null or undefined
            assertParamExists('checkInToClubQuestPost', 'checkInToClubQuestRequestDto', checkInToClubQuestRequestDto);
            const localVarPath = `/checkInToClubQuest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(checkInToClubQuestRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 튜토리얼 전용 화면에서 미션 완료 조건을 충족했을 때 앱이 호출한다. request body 의 missionType 으로 어떤 미션을 완료하려는지 식별하며, 미션별 추가 컨텍스트(예: SAVE_PLACE_LIST 의 placeListId)는 동일 body 에 함께 전달한다.  서버 검증 (미션 타입별): - VIEW_TUTORIAL_IMAGES: 추가 검증 없음 (앱이 튜토리얼 이미지 마지막 장 CTA에서 호출). - REGISTER_INTERESTED_REGIONS_AND_THEMES: 추가 검증 없음 (클라이언트가 등록 직후 호출). - SAVE_PLACE_LIST: 추가 검증 없음 (클라이언트가 저장 직후 placeListId 와 함께 호출). - UPVOTE_ACCESSIBILITY: 추가 검증 없음 (가짜 PDP 에서 사용자 명시 액션 후 호출되므로). - HIDDEN_APP_SURVEY: tally API 로 form 제출 기록 검증. 제출 기록 없으면 400.  idempotent: 이미 완료된 미션이면 no-op + 현재 진행 상태 반환.  튜토리얼 페이지를 거치지 않은 진입 (홈에서 PublicPlaceList 직접 진입 등) 에서는 앱이 이 엔드포인트를 호출하지 않으므로 미션이 완료되지 않는다. 실제 데이터 등록/저장 API (savePlaceList, registerUserInterestedRegionsAndThemes, giveAccessibilityUpvote) 는 미션 진행을 자동 기록하지 않는다.
         * @summary 윌리의 외출 NUX 튜토리얼 미션 완료를 처리한다.
         * @param {CompleteUserTutorialMissionRequestDto} completeUserTutorialMissionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeUserTutorialMission: (completeUserTutorialMissionRequestDto_1, ...args_1) => __awaiter(this, [completeUserTutorialMissionRequestDto_1, ...args_1], void 0, function* (completeUserTutorialMissionRequestDto, options = {}) {
            // verify required parameter 'completeUserTutorialMissionRequestDto' is not null or undefined
            assertParamExists('completeUserTutorialMission', 'completeUserTutorialMissionRequestDto', completeUserTutorialMissionRequestDto);
            const localVarPath = `/completeUserTutorialMission`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(completeUserTutorialMissionRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 비회원 계정을 생성한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnonymousUserPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/createAnonymousUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 장소의 접근성 정보를 요청한다.
         * @param {CreatePlaceAccessibilityInfoRequestRequestDto} createPlaceAccessibilityInfoRequestRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlaceAccessibilityInfoRequestPost: (createPlaceAccessibilityInfoRequestRequestDto_1, ...args_1) => __awaiter(this, [createPlaceAccessibilityInfoRequestRequestDto_1, ...args_1], void 0, function* (createPlaceAccessibilityInfoRequestRequestDto, options = {}) {
            // verify required parameter 'createPlaceAccessibilityInfoRequestRequestDto' is not null or undefined
            assertParamExists('createPlaceAccessibilityInfoRequestPost', 'createPlaceAccessibilityInfoRequestRequestDto', createPlaceAccessibilityInfoRequestRequestDto);
            const localVarPath = `/createPlaceAccessibilityInfoRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createPlaceAccessibilityInfoRequestRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * /savePlace를 사용하세요.
         * @summary 장소를 즐겨찾기에 추가한다.
         * @param {CreatePlaceFavoriteRequestDto} createPlaceFavoriteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createPlaceFavoritePost: (createPlaceFavoriteRequestDto_1, ...args_1) => __awaiter(this, [createPlaceFavoriteRequestDto_1, ...args_1], void 0, function* (createPlaceFavoriteRequestDto, options = {}) {
            // verify required parameter 'createPlaceFavoriteRequestDto' is not null or undefined
            assertParamExists('createPlaceFavoritePost', 'createPlaceFavoriteRequestDto', createPlaceFavoriteRequestDto);
            const localVarPath = `/createPlaceFavorite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(createPlaceFavoriteRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 등록한 건물의 접근성 정보를 삭제한다.
         * @param {DeleteBuildingAccessibilityPostRequest} deleteBuildingAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBuildingAccessibilityPost: (deleteBuildingAccessibilityPostRequest_1, ...args_1) => __awaiter(this, [deleteBuildingAccessibilityPostRequest_1, ...args_1], void 0, function* (deleteBuildingAccessibilityPostRequest, options = {}) {
            // verify required parameter 'deleteBuildingAccessibilityPostRequest' is not null or undefined
            assertParamExists('deleteBuildingAccessibilityPost', 'deleteBuildingAccessibilityPostRequest', deleteBuildingAccessibilityPostRequest);
            const localVarPath = `/deleteBuildingAccessibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deleteBuildingAccessibilityPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 장소의 접근성 정보 요청을 취소한다.
         * @param {DeletePlaceAccessibilityInfoRequestRequestDto} deletePlaceAccessibilityInfoRequestRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaceAccessibilityInfoRequestPost: (deletePlaceAccessibilityInfoRequestRequestDto_1, ...args_1) => __awaiter(this, [deletePlaceAccessibilityInfoRequestRequestDto_1, ...args_1], void 0, function* (deletePlaceAccessibilityInfoRequestRequestDto, options = {}) {
            // verify required parameter 'deletePlaceAccessibilityInfoRequestRequestDto' is not null or undefined
            assertParamExists('deletePlaceAccessibilityInfoRequestPost', 'deletePlaceAccessibilityInfoRequestRequestDto', deletePlaceAccessibilityInfoRequestRequestDto);
            const localVarPath = `/deletePlaceAccessibilityInfoRequest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deletePlaceAccessibilityInfoRequestRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 등록한 장소의 접근성 정보를 삭제한다.
         * @param {DeletePlaceAccessibilityPostRequest} deletePlaceAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaceAccessibilityPost: (deletePlaceAccessibilityPostRequest_1, ...args_1) => __awaiter(this, [deletePlaceAccessibilityPostRequest_1, ...args_1], void 0, function* (deletePlaceAccessibilityPostRequest, options = {}) {
            // verify required parameter 'deletePlaceAccessibilityPostRequest' is not null or undefined
            assertParamExists('deletePlaceAccessibilityPost', 'deletePlaceAccessibilityPostRequest', deletePlaceAccessibilityPostRequest);
            const localVarPath = `/deletePlaceAccessibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deletePlaceAccessibilityPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * /unsavePlace를 사용하세요.
         * @summary 장소를 즐겨찾기에서 삭제한다.
         * @param {DeletePlaceFavoriteRequestDto} deletePlaceFavoriteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deletePlaceFavoritePost: (deletePlaceFavoriteRequestDto_1, ...args_1) => __awaiter(this, [deletePlaceFavoriteRequestDto_1, ...args_1], void 0, function* (deletePlaceFavoriteRequestDto, options = {}) {
            // verify required parameter 'deletePlaceFavoriteRequestDto' is not null or undefined
            assertParamExists('deletePlaceFavoritePost', 'deletePlaceFavoriteRequestDto', deletePlaceFavoriteRequestDto);
            const localVarPath = `/deletePlaceFavorite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deletePlaceFavoriteRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 등록한 장소 리뷰를 삭제한다.
         * @param {DeletePlaceReviewPostRequest} deletePlaceReviewPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaceReviewPost: (deletePlaceReviewPostRequest_1, ...args_1) => __awaiter(this, [deletePlaceReviewPostRequest_1, ...args_1], void 0, function* (deletePlaceReviewPostRequest, options = {}) {
            // verify required parameter 'deletePlaceReviewPostRequest' is not null or undefined
            assertParamExists('deletePlaceReviewPost', 'deletePlaceReviewPostRequest', deletePlaceReviewPostRequest);
            const localVarPath = `/deletePlaceReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deletePlaceReviewPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 등록한 화장실 리뷰를 삭제한다.
         * @param {DeleteToiletReviewPostRequest} deleteToiletReviewPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToiletReviewPost: (deleteToiletReviewPostRequest_1, ...args_1) => __awaiter(this, [deleteToiletReviewPostRequest_1, ...args_1], void 0, function* (deleteToiletReviewPostRequest, options = {}) {
            // verify required parameter 'deleteToiletReviewPostRequest' is not null or undefined
            assertParamExists('deleteToiletReviewPost', 'deleteToiletReviewPostRequest', deleteToiletReviewPostRequest);
            const localVarPath = `/deleteToiletReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(deleteToiletReviewPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 계정을 삭제한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/deleteUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 유저 접근성 정보 정복 활동을 조회한다
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityActivityReportPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/getAccessibilityActivityReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 현재 탑 랭커들을 조회한다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityLeaderboardPost: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getAccessibilityLeaderboardPost', 'body', body);
            const localVarPath = `/getAccessibilityLeaderboard`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 건물 & 점포의 접근성 정보를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityPost: (getAccessibilityPostRequest_1, ...args_1) => __awaiter(this, [getAccessibilityPostRequest_1, ...args_1], void 0, function* (getAccessibilityPostRequest, options = {}) {
            // verify required parameter 'getAccessibilityPostRequest' is not null or undefined
            assertParamExists('getAccessibilityPost', 'getAccessibilityPostRequest', getAccessibilityPostRequest);
            const localVarPath = `/getAccessibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAccessibilityPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 내 현재 랭크를 조회한다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityRankPost: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getAccessibilityRankPost', 'body', body);
            const localVarPath = `/getAccessibilityRank`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 건물 & 점포의 접근성 정보를 조회한다. (v2 - 클로즈 베타)
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityV2Post: (getAccessibilityPostRequest_1, ...args_1) => __awaiter(this, [getAccessibilityPostRequest_1, ...args_1], void 0, function* (getAccessibilityPostRequest, options = {}) {
            // verify required parameter 'getAccessibilityPostRequest' is not null or undefined
            assertParamExists('getAccessibilityV2Post', 'getAccessibilityPostRequest', getAccessibilityPostRequest);
            const localVarPath = `/getAccessibilityV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAccessibilityPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 검색 결과에 접근레벨 2 이하인 장소가 하나도 없을 때(부정경험 상태) 클라이언트가 지도 카드 포커스가 확정될 때마다 호출한다. 해당 장소의 vendor 세부 카테고리(예: 한식)를 대체 검색어 후보로 뽑아 실제 재검색을 시뮬레이션하고, 접근레벨 2 이하 결과가 3개를 초과할 때만 제안을 내려준다. 제안할 것이 없으면 suggestion이 null이다. 비인증 유저도 조회 가능하다.
         * @summary 포커스된 장소를 기준으로 대체 검색어를 제안할지 판단한다.
         * @param {GetAlternativeSearchSuggestionRequestDto} getAlternativeSearchSuggestionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlternativeSearchSuggestion: (getAlternativeSearchSuggestionRequestDto_1, ...args_1) => __awaiter(this, [getAlternativeSearchSuggestionRequestDto_1, ...args_1], void 0, function* (getAlternativeSearchSuggestionRequestDto, options = {}) {
            // verify required parameter 'getAlternativeSearchSuggestionRequestDto' is not null or undefined
            assertParamExists('getAlternativeSearchSuggestion', 'getAlternativeSearchSuggestionRequestDto', getAlternativeSearchSuggestionRequestDto);
            const localVarPath = `/getAlternativeSearchSuggestion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAlternativeSearchSuggestionRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 뿌클로드 페이지 정보를 조회한다.
         * @param {GetBbucleRoadPageRequestDto} getBbucleRoadPageRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBbucleRoadPage: (getBbucleRoadPageRequestDto_1, ...args_1) => __awaiter(this, [getBbucleRoadPageRequestDto_1, ...args_1], void 0, function* (getBbucleRoadPageRequestDto, options = {}) {
            // verify required parameter 'getBbucleRoadPageRequestDto' is not null or undefined
            assertParamExists('getBbucleRoadPage', 'getBbucleRoadPageRequestDto', getBbucleRoadPageRequestDto);
            const localVarPath = `/getBbucleRoadPage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getBbucleRoadPageRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 챌린지 리스트에서 공개된 챌린지를 선택해서 챌린지를 조회한다.
         * @param {GetChallengeRequestDto} getChallengeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengePost: (getChallengeRequestDto_1, ...args_1) => __awaiter(this, [getChallengeRequestDto_1, ...args_1], void 0, function* (getChallengeRequestDto, options = {}) {
            // verify required parameter 'getChallengeRequestDto' is not null or undefined
            assertParamExists('getChallengePost', 'getChallengeRequestDto', getChallengeRequestDto);
            const localVarPath = `/getChallenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getChallengeRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 공개되지 않은 챌린지를 초대코드를 통해 챌린지를 조회한다.
         * @param {GetChallengeWithInvitationCodeRequestDto} getChallengeWithInvitationCodeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeWithInvitationCodePost: (getChallengeWithInvitationCodeRequestDto_1, ...args_1) => __awaiter(this, [getChallengeWithInvitationCodeRequestDto_1, ...args_1], void 0, function* (getChallengeWithInvitationCodeRequestDto, options = {}) {
            // verify required parameter 'getChallengeWithInvitationCodeRequestDto' is not null or undefined
            assertParamExists('getChallengeWithInvitationCodePost', 'getChallengeWithInvitationCodeRequestDto', getChallengeWithInvitationCodeRequestDto);
            const localVarPath = `/getChallengeWithInvitationCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getChallengeWithInvitationCodeRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 앱 버전에 따라 업데이트 상태를 알려준다
         * @param {GetClientVersionStatusRequestDto} getClientVersionStatusRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientVersionStatusPost: (getClientVersionStatusRequestDto_1, ...args_1) => __awaiter(this, [getClientVersionStatusRequestDto_1, ...args_1], void 0, function* (getClientVersionStatusRequestDto, options = {}) {
            // verify required parameter 'getClientVersionStatusRequestDto' is not null or undefined
            assertParamExists('getClientVersionStatusPost', 'getClientVersionStatusRequestDto', getClientVersionStatusRequestDto);
            const localVarPath = `/getClientVersionStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getClientVersionStatusRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 다음 랭크로 올라가기 위한 점수를 조회한다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountForNextRankPost: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('getCountForNextRankPost', 'body', body);
            const localVarPath = `/getCountForNextRank`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 크러셔 활동 페이지를 그리기 위한 데이터를 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrusherActivityPageDataPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/getCrusherActivityPageData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 특정 크러셔 클럽의 활동 정보를 조회한다.
         * @param {GetCrusherActivityRequestDto} getCrusherActivityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrusherActivityPost: (getCrusherActivityRequestDto_1, ...args_1) => __awaiter(this, [getCrusherActivityRequestDto_1, ...args_1], void 0, function* (getCrusherActivityRequestDto, options = {}) {
            // verify required parameter 'getCrusherActivityRequestDto' is not null or undefined
            assertParamExists('getCrusherActivityPost', 'getCrusherActivityRequestDto', getCrusherActivityRequestDto);
            const localVarPath = `/getCrusherActivity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getCrusherActivityRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary /getCrusherActivityPage 로 대체됨
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCurrentCrusherActivityPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/getCurrentCrusherActivity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 공공 접근성 정보를 확인한다.
         * @param {GetExternalAccessibilityPostRequest} getExternalAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAccessibilityPost: (getExternalAccessibilityPostRequest_1, ...args_1) => __awaiter(this, [getExternalAccessibilityPostRequest_1, ...args_1], void 0, function* (getExternalAccessibilityPostRequest, options = {}) {
            // verify required parameter 'getExternalAccessibilityPostRequest' is not null or undefined
            assertParamExists('getExternalAccessibilityPost', 'getExternalAccessibilityPostRequest', getExternalAccessibilityPostRequest);
            const localVarPath = `/getExternalAccessibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getExternalAccessibilityPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 홈에서 보여줄 배너 정보 목록을 가져온다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeBanners: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/getHomeBanners`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 홈 화면에 필요한 모든 데이터를 가져온다.
         * @param {GetHomeScreenDataRequestDto} [getHomeScreenDataRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeScreenData: (getHomeScreenDataRequestDto_1, ...args_1) => __awaiter(this, [getHomeScreenDataRequestDto_1, ...args_1], void 0, function* (getHomeScreenDataRequestDto, options = {}) {
            const localVarPath = `/getHomeScreenData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getHomeScreenDataRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 점포 정보 등록 등의 상황에서 이미지를 업로드하기 위한 URL을 받아 온다.
         * @param {GetImageUploadUrlsPostRequest} getImageUploadUrlsPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageUploadUrlsPost: (getImageUploadUrlsPostRequest_1, ...args_1) => __awaiter(this, [getImageUploadUrlsPostRequest_1, ...args_1], void 0, function* (getImageUploadUrlsPostRequest, options = {}) {
            // verify required parameter 'getImageUploadUrlsPostRequest' is not null or undefined
            assertParamExists('getImageUploadUrlsPost', 'getImageUploadUrlsPostRequest', getImageUploadUrlsPostRequest);
            const localVarPath = `/getImageUploadUrls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getImageUploadUrlsPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 주변 정복 상태를 조회한다.
         * @param {GetNearbyAccessibilityStatusPostRequest} getNearbyAccessibilityStatusPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNearbyAccessibilityStatusPost: (getNearbyAccessibilityStatusPostRequest_1, ...args_1) => __awaiter(this, [getNearbyAccessibilityStatusPostRequest_1, ...args_1], void 0, function* (getNearbyAccessibilityStatusPostRequest, options = {}) {
            // verify required parameter 'getNearbyAccessibilityStatusPostRequest' is not null or undefined
            assertParamExists('getNearbyAccessibilityStatusPost', 'getNearbyAccessibilityStatusPostRequest', getNearbyAccessibilityStatusPostRequest);
            const localVarPath = `/getNearbyAccessibilityStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getNearbyAccessibilityStatusPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary PlaceList(저장 리스트)를 조회한다.
         * @param {GetPlaceListRequestDto} getPlaceListRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaceList: (getPlaceListRequestDto_1, ...args_1) => __awaiter(this, [getPlaceListRequestDto_1, ...args_1], void 0, function* (getPlaceListRequestDto, options = {}) {
            // verify required parameter 'getPlaceListRequestDto' is not null or undefined
            assertParamExists('getPlaceList', 'getPlaceListRequestDto', getPlaceListRequestDto);
            const localVarPath = `/getPlaceList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getPlaceListRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 건물 & 점포 정보를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaceWithBuildingPost: (getAccessibilityPostRequest_1, ...args_1) => __awaiter(this, [getAccessibilityPostRequest_1, ...args_1], void 0, function* (getAccessibilityPostRequest, options = {}) {
            // verify required parameter 'getAccessibilityPostRequest' is not null or undefined
            assertParamExists('getPlaceWithBuildingPost', 'getAccessibilityPostRequest', getAccessibilityPostRequest);
            const localVarPath = `/getPlaceWithBuilding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAccessibilityPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 유저의 리뷰 등록 활동을 조회한다
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewActivityReportPost: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/getReviewActivityReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * sccContentId 로 SccContent 를 조회한다. 비로그인 사용자도 호출 가능하다 (예: 공유된 컨텐츠 링크로 진입).
         * @summary SccContent 단건을 id로 조회한다.
         * @param {GetSccContentRequestDto} getSccContentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSccContent: (getSccContentRequestDto_1, ...args_1) => __awaiter(this, [getSccContentRequestDto_1, ...args_1], void 0, function* (getSccContentRequestDto, options = {}) {
            // verify required parameter 'getSccContentRequestDto' is not null or undefined
            assertParamExists('getSccContent', 'getSccContentRequestDto', getSccContentRequestDto);
            const localVarPath = `/getSccContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getSccContentRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 웹뷰 진입 시 라운드트립 1회로 끝낼 수 있도록 저장 상태와 좋아요 요약을 통합 응답한다. - URL 기준으로 SccContent id + 현재 유저의 저장 여부. - 서버가 URL pattern 에서 좋아요 target 을 추론하여 응답의 upvoteSummary 에 좋아요 요약(totalCount, isUpvoted) 을 채운다.   (BBUCLE_ROAD: con.staircrusher.club / staircrusherclub.notion.site 의 path id, ARTICLE: web.staircrusher.club/articles/ 이하 경로) - 좋아요 개념이 적용되지 않는 URL 이면 upvoteSummary 는 null. - 한 번도 저장된 적 없는 URL이면 sccContentId 는 null 로 응답한다.
         * @summary 웹뷰 컨텐츠의 저장 상태 + 좋아요 요약을 한 번에 조회한다.
         * @param {GetSccContentDetailsRequestDto} getSccContentDetailsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSccContentDetails: (getSccContentDetailsRequestDto_1, ...args_1) => __awaiter(this, [getSccContentDetailsRequestDto_1, ...args_1], void 0, function* (getSccContentDetailsRequestDto, options = {}) {
            // verify required parameter 'getSccContentDetailsRequestDto' is not null or undefined
            assertParamExists('getSccContentDetails', 'getSccContentDetailsRequestDto', getSccContentDetailsRequestDto);
            const localVarPath = `/getSccContentDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getSccContentDetailsRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 도움이 되었어요를 누른 사람들과 통계를 받아온다
         * @param {GetUpvoteDetailsRequestDto} getUpvoteDetailsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpvoteDetailsPost: (getUpvoteDetailsRequestDto_1, ...args_1) => __awaiter(this, [getUpvoteDetailsRequestDto_1, ...args_1], void 0, function* (getUpvoteDetailsRequestDto, options = {}) {
            // verify required parameter 'getUpvoteDetailsRequestDto' is not null or undefined
            assertParamExists('getUpvoteDetailsPost', 'getUpvoteDetailsRequestDto', getUpvoteDetailsRequestDto);
            const localVarPath = `/getUpvoteDetails`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getUpvoteDetailsRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 유저 정보를 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoGet: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/getUserInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 로그인 사용자는 본인의 저장된 미션 진행 상태를 반환받는다. 익명 사용자도 호출 가능하며, 이 경우 모든 미션이 미완료 상태로 반환된다.
         * @summary 윌리의 외출 NUX 튜토리얼 미션 진행 상태를 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTutorialProgress: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/getUserTutorialProgress`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 건물에 대해 \'이 정보가 도움이 돼요\'를 준다.
         * @param {GiveBuildingAccessibilityUpvoteRequestDto} giveBuildingAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        giveBuildingAccessibilityUpvotePost: (giveBuildingAccessibilityUpvoteRequestDto_1, ...args_1) => __awaiter(this, [giveBuildingAccessibilityUpvoteRequestDto_1, ...args_1], void 0, function* (giveBuildingAccessibilityUpvoteRequestDto, options = {}) {
            // verify required parameter 'giveBuildingAccessibilityUpvoteRequestDto' is not null or undefined
            assertParamExists('giveBuildingAccessibilityUpvotePost', 'giveBuildingAccessibilityUpvoteRequestDto', giveBuildingAccessibilityUpvoteRequestDto);
            const localVarPath = `/giveBuildingAccessibilityUpvote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(giveBuildingAccessibilityUpvoteRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 장소에 대해 \'이 정보가 도움이 돼요\'를 준다.
         * @param {GivePlaceAccessibilityUpvoteRequestDto} givePlaceAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        givePlaceAccessibilityUpvotePost: (givePlaceAccessibilityUpvoteRequestDto_1, ...args_1) => __awaiter(this, [givePlaceAccessibilityUpvoteRequestDto_1, ...args_1], void 0, function* (givePlaceAccessibilityUpvoteRequestDto, options = {}) {
            // verify required parameter 'givePlaceAccessibilityUpvoteRequestDto' is not null or undefined
            assertParamExists('givePlaceAccessibilityUpvotePost', 'givePlaceAccessibilityUpvoteRequestDto', givePlaceAccessibilityUpvoteRequestDto);
            const localVarPath = `/givePlaceAccessibilityUpvote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(givePlaceAccessibilityUpvoteRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary PDP AI 접근성 요약에 붐업/붐따를 남긴다. 같은 장소에 다시 호출하면 덮어쓴다.
         * @param {GivePlaceAiSummaryFeedbackRequestDto} givePlaceAiSummaryFeedbackRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        givePlaceAiSummaryFeedbackPost: (givePlaceAiSummaryFeedbackRequestDto_1, ...args_1) => __awaiter(this, [givePlaceAiSummaryFeedbackRequestDto_1, ...args_1], void 0, function* (givePlaceAiSummaryFeedbackRequestDto, options = {}) {
            // verify required parameter 'givePlaceAiSummaryFeedbackRequestDto' is not null or undefined
            assertParamExists('givePlaceAiSummaryFeedbackPost', 'givePlaceAiSummaryFeedbackRequestDto', givePlaceAiSummaryFeedbackRequestDto);
            const localVarPath = `/givePlaceAiSummaryFeedback`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(givePlaceAiSummaryFeedbackRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary \'도움이 돼요\'를 준다.
         * @param {GiveUpvoteRequestDto} giveUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveUpvotePost: (giveUpvoteRequestDto_1, ...args_1) => __awaiter(this, [giveUpvoteRequestDto_1, ...args_1], void 0, function* (giveUpvoteRequestDto, options = {}) {
            // verify required parameter 'giveUpvoteRequestDto' is not null or undefined
            assertParamExists('giveUpvotePost', 'giveUpvoteRequestDto', giveUpvoteRequestDto);
            const localVarPath = `/giveUpvote`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(giveUpvoteRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 챌린지에 참여한다.
         * @param {JoinChallengeRequestDto} joinChallengeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinChallengePost: (joinChallengeRequestDto_1, ...args_1) => __awaiter(this, [joinChallengeRequestDto_1, ...args_1], void 0, function* (joinChallengeRequestDto, options = {}) {
            // verify required parameter 'joinChallengeRequestDto' is not null or undefined
            assertParamExists('joinChallengePost', 'joinChallengeRequestDto', joinChallengeRequestDto);
            const localVarPath = `/joinChallenge`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(joinChallengeRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * challenge.hasConquerTargetPlaceList 가 true 인 챌린지에서만 호출 가능하다. 연결된 정복 대상 장소 목록이 없으면 400 을 내려준다.
         * @summary 챌린지에 연결된 정복 대상 장소 목록을 조회한다.
         * @param {ListChallengeConquerTargetPlacesRequestDto} listChallengeConquerTargetPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChallengeConquerTargetPlacesPost: (listChallengeConquerTargetPlacesRequestDto_1, ...args_1) => __awaiter(this, [listChallengeConquerTargetPlacesRequestDto_1, ...args_1], void 0, function* (listChallengeConquerTargetPlacesRequestDto, options = {}) {
            // verify required parameter 'listChallengeConquerTargetPlacesRequestDto' is not null or undefined
            assertParamExists('listChallengeConquerTargetPlacesPost', 'listChallengeConquerTargetPlacesRequestDto', listChallengeConquerTargetPlacesRequestDto);
            const localVarPath = `/listChallengeConquerTargetPlaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listChallengeConquerTargetPlacesRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 공개된 챌린지 리스트를 조회한다.
         * @param {ListChallengesRequestDto} listChallengesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChallengesPost: (listChallengesRequestDto_1, ...args_1) => __awaiter(this, [listChallengesRequestDto_1, ...args_1], void 0, function* (listChallengesRequestDto, options = {}) {
            // verify required parameter 'listChallengesRequestDto' is not null or undefined
            assertParamExists('listChallengesPost', 'listChallengesRequestDto', listChallengesRequestDto);
            const localVarPath = `/listChallenges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listChallengesRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 내가 정복한 장소 목록을 조회한다.
         * @param {ListConqueredPlacesRequestDto} listConqueredPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConqueredPlacesPost: (listConqueredPlacesRequestDto_1, ...args_1) => __awaiter(this, [listConqueredPlacesRequestDto_1, ...args_1], void 0, function* (listConqueredPlacesRequestDto, options = {}) {
            // verify required parameter 'listConqueredPlacesRequestDto' is not null or undefined
            assertParamExists('listConqueredPlacesPost', 'listConqueredPlacesRequestDto', listConqueredPlacesRequestDto);
            const localVarPath = `/listConqueredPlaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listConqueredPlacesRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 윌리의 외출 NUX 튜토리얼 첫 번째 메인 미션의 관심 지역 선택 화면(Figma 1648-41115)에서 사용한다. 시도 단위로 그룹핑된 시군구 그룹 목록을 반환한다. 앱이 정적으로 들고 있지 않고 서버에서 받아오게 하여, 지역 목록을 서버에서 자유롭게 확장할 수 있도록 한다.
         * @summary 관심 지역 등록 시 사용할 시도/시군구 그룹 목록을 가져온다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterestedRegions: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/listInterestedRegions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 즐겨찾기한 장소 목록을 조회한다.
         * @param {ListPlaceFavoritesRequestDto} listPlaceFavoritesRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listPlaceFavoritesPost: (listPlaceFavoritesRequestDto_1, ...args_1) => __awaiter(this, [listPlaceFavoritesRequestDto_1, ...args_1], void 0, function* (listPlaceFavoritesRequestDto, options = {}) {
            // verify required parameter 'listPlaceFavoritesRequestDto' is not null or undefined
            assertParamExists('listPlaceFavoritesPost', 'listPlaceFavoritesRequestDto', listPlaceFavoritesRequestDto);
            const localVarPath = `/listPlaceFavorites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listPlaceFavoritesRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 실내 리뷰를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlaceReviewsPost: (getAccessibilityPostRequest_1, ...args_1) => __awaiter(this, [getAccessibilityPostRequest_1, ...args_1], void 0, function* (getAccessibilityPostRequest, options = {}) {
            // verify required parameter 'getAccessibilityPostRequest' is not null or undefined
            assertParamExists('listPlaceReviewsPost', 'getAccessibilityPostRequest', getAccessibilityPostRequest);
            const localVarPath = `/listPlaceReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAccessibilityPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 현재 지도 중심점(currentLocation)이 추천 항목의 폴리곤 내부에 있으면 해당 추천을 반환한다. 매칭되는 추천이 없으면 빈 배열을 반환한다. 비인증 사용자도 조회 가능하다.
         * @summary 현재 지도 영역에 해당하는 장소 검색 추천 목록을 조회한다.
         * @param {ListPlaceSearchRecommendationsRequestDto} listPlaceSearchRecommendationsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlaceSearchRecommendations: (listPlaceSearchRecommendationsRequestDto_1, ...args_1) => __awaiter(this, [listPlaceSearchRecommendationsRequestDto_1, ...args_1], void 0, function* (listPlaceSearchRecommendationsRequestDto, options = {}) {
            // verify required parameter 'listPlaceSearchRecommendationsRequestDto' is not null or undefined
            assertParamExists('listPlaceSearchRecommendations', 'listPlaceSearchRecommendationsRequestDto', listPlaceSearchRecommendationsRequestDto);
            const localVarPath = `/listPlaceSearchRecommendations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listPlaceSearchRecommendationsRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * \'이 건물에 다른 점포 등록하기\'를 눌렀을 때 호출된다.
         * @summary 특정 건물의 점포를 조회한다.
         * @param {ListPlacesInBuildingPostRequest} listPlacesInBuildingPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlacesInBuildingPost: (listPlacesInBuildingPostRequest_1, ...args_1) => __awaiter(this, [listPlacesInBuildingPostRequest_1, ...args_1], void 0, function* (listPlacesInBuildingPostRequest, options = {}) {
            // verify required parameter 'listPlacesInBuildingPostRequest' is not null or undefined
            assertParamExists('listPlacesInBuildingPost', 'listPlacesInBuildingPostRequest', listPlacesInBuildingPostRequest);
            const localVarPath = `/listPlacesInBuilding`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listPlacesInBuildingPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Google Drive 파일 공유 모델과 유사한 접근 제어를 따른다. - `PUBLIC` 리스트는 모든 사용자(익명 포함)에게 노출된다. - `LINK_ONLY` 리스트는 NUX 튜토리얼의 모든 메인 미션을 완료한 식별 사용자에게만 노출된다. - `PRIVATE` 리스트는 노출되지 않는다.
         * @summary 공개된 PlaceList 목록을 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPublicPlaceLists: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/listPublicPlaceLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 내가 작성한 내부 공간 리뷰를 페이징 해서 가져온다.
         * @param {ListRegisteredReviewsRequestDto} listRegisteredReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegisteredPlaceReviewsPost: (listRegisteredReviewsRequestDto_1, ...args_1) => __awaiter(this, [listRegisteredReviewsRequestDto_1, ...args_1], void 0, function* (listRegisteredReviewsRequestDto, options = {}) {
            // verify required parameter 'listRegisteredReviewsRequestDto' is not null or undefined
            assertParamExists('listRegisteredPlaceReviewsPost', 'listRegisteredReviewsRequestDto', listRegisteredReviewsRequestDto);
            const localVarPath = `/listRegisteredPlaceReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listRegisteredReviewsRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 내가 작성한 화장실 리뷰를 페이징 해서 가져온다.
         * @param {ListRegisteredReviewsRequestDto} listRegisteredReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegisteredToiletReviewsPost: (listRegisteredReviewsRequestDto_1, ...args_1) => __awaiter(this, [listRegisteredReviewsRequestDto_1, ...args_1], void 0, function* (listRegisteredReviewsRequestDto, options = {}) {
            // verify required parameter 'listRegisteredReviewsRequestDto' is not null or undefined
            assertParamExists('listRegisteredToiletReviewsPost', 'listRegisteredReviewsRequestDto', listRegisteredReviewsRequestDto);
            const localVarPath = `/listRegisteredToiletReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listRegisteredReviewsRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 저장 시각 역순(createdAt DESC)으로 페이징한다. \'저장한 장소\' 페이지의 \'저장한 컨텐츠\' 탭에서 사용한다.
         * @summary 저장한 컨텐츠 목록을 조회한다.
         * @param {ListSavedContentsRequestDto} listSavedContentsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSavedContents: (listSavedContentsRequestDto_1, ...args_1) => __awaiter(this, [listSavedContentsRequestDto_1, ...args_1], void 0, function* (listSavedContentsRequestDto, options = {}) {
            // verify required parameter 'listSavedContentsRequestDto' is not null or undefined
            assertParamExists('listSavedContents', 'listSavedContentsRequestDto', listSavedContentsRequestDto);
            const localVarPath = `/listSavedContents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listSavedContentsRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 내가 저장한 PlaceList 목록을 조회한다.
         * @param {ListSavedPlaceListsRequestDto} listSavedPlaceListsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSavedPlaceLists: (listSavedPlaceListsRequestDto_1, ...args_1) => __awaiter(this, [listSavedPlaceListsRequestDto_1, ...args_1], void 0, function* (listSavedPlaceListsRequestDto, options = {}) {
            // verify required parameter 'listSavedPlaceListsRequestDto' is not null or undefined
            assertParamExists('listSavedPlaceLists', 'listSavedPlaceListsRequestDto', listSavedPlaceListsRequestDto);
            const localVarPath = `/listSavedPlaceLists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listSavedPlaceListsRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 음식점, 카페, 편의점, 병원 같이 키워드를 내려주면 searchPlaces 키워드로 쓸 수 있습니다.
         * @summary 특정 카테고리의 점포들을 검색할 수 있게 키워드들을 내려준다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSearchKeywordsOfPlaceCategoryPost: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('listSearchKeywordsOfPlaceCategoryPost', 'body', body);
            const localVarPath = `/listSearchKeywordsOfPlaceCategory`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 현재는 추천 키워드만 내려준다
         * @summary 특정 조건의 검색을 할 수 있는 추천 값을 내려준다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSearchPlacePresetsPost: (body_1, ...args_1) => __awaiter(this, [body_1, ...args_1], void 0, function* (body, options = {}) {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('listSearchPlacePresetsPost', 'body', body);
            const localVarPath = `/listSearchPlacePresets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 화장실 리뷰를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listToiletReviewsPost: (getAccessibilityPostRequest_1, ...args_1) => __awaiter(this, [getAccessibilityPostRequest_1, ...args_1], void 0, function* (getAccessibilityPostRequest, options = {}) {
            // verify required parameter 'getAccessibilityPostRequest' is not null or undefined
            assertParamExists('listToiletReviewsPost', 'getAccessibilityPostRequest', getAccessibilityPostRequest);
            const localVarPath = `/listToiletReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getAccessibilityPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 내가 작성한 내부 공간 리뷰 중 도움이 되었어요를 받은 리뷰를 페이징 해서 가져온다.
         * @param {ListUpvotedReviewsRequestDto} listUpvotedReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpvotedPlaceReviewsPost: (listUpvotedReviewsRequestDto_1, ...args_1) => __awaiter(this, [listUpvotedReviewsRequestDto_1, ...args_1], void 0, function* (listUpvotedReviewsRequestDto, options = {}) {
            // verify required parameter 'listUpvotedReviewsRequestDto' is not null or undefined
            assertParamExists('listUpvotedPlaceReviewsPost', 'listUpvotedReviewsRequestDto', listUpvotedReviewsRequestDto);
            const localVarPath = `/listUpvotedPlaceReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listUpvotedReviewsRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 내가 등록한 접근성 정보(건물/장소) 중 도움이 되었어요를 받은 장소를 페이징 해서 가져온다
         * @param {ListUpvotedPlacesRequestDto} listUpvotedPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpvotedPlacesPost: (listUpvotedPlacesRequestDto_1, ...args_1) => __awaiter(this, [listUpvotedPlacesRequestDto_1, ...args_1], void 0, function* (listUpvotedPlacesRequestDto, options = {}) {
            // verify required parameter 'listUpvotedPlacesRequestDto' is not null or undefined
            assertParamExists('listUpvotedPlacesPost', 'listUpvotedPlacesRequestDto', listUpvotedPlacesRequestDto);
            const localVarPath = `/listUpvotedPlaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listUpvotedPlacesRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 내가 작성한 화장실 리뷰 중 도움이 되었어요를 받은 리뷰를 페이징 해서 가져온다.
         * @param {ListUpvotedReviewsRequestDto} listUpvotedReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpvotedToiletReviewsPost: (listUpvotedReviewsRequestDto_1, ...args_1) => __awaiter(this, [listUpvotedReviewsRequestDto_1, ...args_1], void 0, function* (listUpvotedReviewsRequestDto, options = {}) {
            // verify required parameter 'listUpvotedReviewsRequestDto' is not null or undefined
            assertParamExists('listUpvotedToiletReviewsPost', 'listUpvotedReviewsRequestDto', listUpvotedReviewsRequestDto);
            const localVarPath = `/listUpvotedToiletReviews`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(listUpvotedReviewsRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 로그인을 한다.
         * @param {LoginPostRequest} loginPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginPost: (loginPostRequest_1, ...args_1) => __awaiter(this, [loginPostRequest_1, ...args_1], void 0, function* (loginPostRequest, options = {}) {
            // verify required parameter 'loginPostRequest' is not null or undefined
            assertParamExists('loginPost', 'loginPostRequest', loginPostRequest);
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(loginPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 애플 로그인을 통해 로그인 or 회원가입을 한다.
         * @param {LoginWithAppleRequestDto} loginWithAppleRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithApplePost: (loginWithAppleRequestDto_1, ...args_1) => __awaiter(this, [loginWithAppleRequestDto_1, ...args_1], void 0, function* (loginWithAppleRequestDto, options = {}) {
            // verify required parameter 'loginWithAppleRequestDto' is not null or undefined
            assertParamExists('loginWithApplePost', 'loginWithAppleRequestDto', loginWithAppleRequestDto);
            const localVarPath = `/loginWithApple`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(loginWithAppleRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 카카오 로그인을 통해 로그인 or 회원가입을 한다.
         * @param {LoginWithKakaoPostRequest} loginWithKakaoPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithKakaoPost: (loginWithKakaoPostRequest_1, ...args_1) => __awaiter(this, [loginWithKakaoPostRequest_1, ...args_1], void 0, function* (loginWithKakaoPostRequest, options = {}) {
            // verify required parameter 'loginWithKakaoPostRequest' is not null or undefined
            assertParamExists('loginWithKakaoPost', 'loginWithKakaoPostRequest', loginWithKakaoPostRequest);
            const localVarPath = `/loginWithKakao`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(loginWithKakaoPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 크러셔 활동을 기록한다.
         * @param {RecordCrusherClubActivityRequestDto} recordCrusherClubActivityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordCrusherClubActivityPost: (recordCrusherClubActivityRequestDto_1, ...args_1) => __awaiter(this, [recordCrusherClubActivityRequestDto_1, ...args_1], void 0, function* (recordCrusherClubActivityRequestDto, options = {}) {
            // verify required parameter 'recordCrusherClubActivityRequestDto' is not null or undefined
            assertParamExists('recordCrusherClubActivityPost', 'recordCrusherClubActivityRequestDto', recordCrusherClubActivityRequestDto);
            const localVarPath = `/recordCrusherClubActivity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(recordCrusherClubActivityRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 건물에 의견을 추가한다.
         * @param {RegisterBuildingAccessibilityCommentPostRequest} registerBuildingAccessibilityCommentPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBuildingAccessibilityCommentPost: (registerBuildingAccessibilityCommentPostRequest_1, ...args_1) => __awaiter(this, [registerBuildingAccessibilityCommentPostRequest_1, ...args_1], void 0, function* (registerBuildingAccessibilityCommentPostRequest, options = {}) {
            // verify required parameter 'registerBuildingAccessibilityCommentPostRequest' is not null or undefined
            assertParamExists('registerBuildingAccessibilityCommentPost', 'registerBuildingAccessibilityCommentPostRequest', registerBuildingAccessibilityCommentPostRequest);
            const localVarPath = `/registerBuildingAccessibilityComment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerBuildingAccessibilityCommentPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 건물 접근성 정보를 등록한다.
         * @param {RegisterBuildingAccessibilityRequestDto} registerBuildingAccessibilityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBuildingAccessibilityPost: (registerBuildingAccessibilityRequestDto_1, ...args_1) => __awaiter(this, [registerBuildingAccessibilityRequestDto_1, ...args_1], void 0, function* (registerBuildingAccessibilityRequestDto, options = {}) {
            // verify required parameter 'registerBuildingAccessibilityRequestDto' is not null or undefined
            assertParamExists('registerBuildingAccessibilityPost', 'registerBuildingAccessibilityRequestDto', registerBuildingAccessibilityRequestDto);
            const localVarPath = `/registerBuildingAccessibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerBuildingAccessibilityRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 건물 입구 및 엘리베이터 접근성 정보를 등록한다. (v2 - 클로즈 베타)
         * @param {RegisterBuildingAccessibilityRequestDtoV2} registerBuildingAccessibilityRequestDtoV2
         * @param {string} [xSCCREQUESTID] Optional request ID header used for tracing, logging, and idempotency. 클라이언트에서 동일한 요청을 여러 번 보내도 한 번만 처리되도록 보장합니다. 같은 X-SCC-REQUEST-ID로 요청이 오면 이전 결과를 반환합니다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBuildingAccessibilityV2Post: (registerBuildingAccessibilityRequestDtoV2_1, xSCCREQUESTID_1, ...args_1) => __awaiter(this, [registerBuildingAccessibilityRequestDtoV2_1, xSCCREQUESTID_1, ...args_1], void 0, function* (registerBuildingAccessibilityRequestDtoV2, xSCCREQUESTID, options = {}) {
            // verify required parameter 'registerBuildingAccessibilityRequestDtoV2' is not null or undefined
            assertParamExists('registerBuildingAccessibilityV2Post', 'registerBuildingAccessibilityRequestDtoV2', registerBuildingAccessibilityRequestDtoV2);
            const localVarPath = `/registerBuildingAccessibilityV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xSCCREQUESTID != null) {
                localVarHeaderParameter['X-SCC-REQUEST-ID'] = String(xSCCREQUESTID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerBuildingAccessibilityRequestDtoV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 사람이 검수한 접근성 정보 결과를 등록한다.
         * @param {RegisterHumanInspectionResultRequestDto} registerHumanInspectionResultRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerHumanInspectionResultPost: (registerHumanInspectionResultRequestDto_1, ...args_1) => __awaiter(this, [registerHumanInspectionResultRequestDto_1, ...args_1], void 0, function* (registerHumanInspectionResultRequestDto, options = {}) {
            // verify required parameter 'registerHumanInspectionResultRequestDto' is not null or undefined
            assertParamExists('registerHumanInspectionResultPost', 'registerHumanInspectionResultRequestDto', registerHumanInspectionResultRequestDto);
            const localVarPath = `/registerHumanInspectionResult`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerHumanInspectionResultRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 점포에 의견을 추가한다.
         * @param {RegisterPlaceAccessibilityCommentPostRequest} registerPlaceAccessibilityCommentPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceAccessibilityCommentPost: (registerPlaceAccessibilityCommentPostRequest_1, ...args_1) => __awaiter(this, [registerPlaceAccessibilityCommentPostRequest_1, ...args_1], void 0, function* (registerPlaceAccessibilityCommentPostRequest, options = {}) {
            // verify required parameter 'registerPlaceAccessibilityCommentPostRequest' is not null or undefined
            assertParamExists('registerPlaceAccessibilityCommentPost', 'registerPlaceAccessibilityCommentPostRequest', registerPlaceAccessibilityCommentPostRequest);
            const localVarPath = `/registerPlaceAccessibilityComment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerPlaceAccessibilityCommentPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 점포의 접근성 정보를 등록한다.
         * @param {RegisterPlaceAccessibilityRequestDto} registerPlaceAccessibilityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceAccessibilityPost: (registerPlaceAccessibilityRequestDto_1, ...args_1) => __awaiter(this, [registerPlaceAccessibilityRequestDto_1, ...args_1], void 0, function* (registerPlaceAccessibilityRequestDto, options = {}) {
            // verify required parameter 'registerPlaceAccessibilityRequestDto' is not null or undefined
            assertParamExists('registerPlaceAccessibilityPost', 'registerPlaceAccessibilityRequestDto', registerPlaceAccessibilityRequestDto);
            const localVarPath = `/registerPlaceAccessibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerPlaceAccessibilityRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 장소 입구 접근성 정보를 등록한다. (v2 - 클로즈 베타)
         * @param {RegisterPlaceAccessibilityRequestDtoV2} registerPlaceAccessibilityRequestDtoV2
         * @param {string} [xSCCREQUESTID] Optional request ID header used for tracing, logging, and idempotency. 클라이언트에서 동일한 요청을 여러 번 보내도 한 번만 처리되도록 보장합니다. 같은 X-SCC-REQUEST-ID로 요청이 오면 이전 결과를 반환합니다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceAccessibilityV2Post: (registerPlaceAccessibilityRequestDtoV2_1, xSCCREQUESTID_1, ...args_1) => __awaiter(this, [registerPlaceAccessibilityRequestDtoV2_1, xSCCREQUESTID_1, ...args_1], void 0, function* (registerPlaceAccessibilityRequestDtoV2, xSCCREQUESTID, options = {}) {
            // verify required parameter 'registerPlaceAccessibilityRequestDtoV2' is not null or undefined
            assertParamExists('registerPlaceAccessibilityV2Post', 'registerPlaceAccessibilityRequestDtoV2', registerPlaceAccessibilityRequestDtoV2);
            const localVarPath = `/registerPlaceAccessibilityV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (xSCCREQUESTID != null) {
                localVarHeaderParameter['X-SCC-REQUEST-ID'] = String(xSCCREQUESTID);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerPlaceAccessibilityRequestDtoV2, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 점포의 내부 및 방문 리뷰 정보를 등록한다.
         * @param {RegisterPlaceReviewRequestDto} registerPlaceReviewRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceReviewPost: (registerPlaceReviewRequestDto_1, ...args_1) => __awaiter(this, [registerPlaceReviewRequestDto_1, ...args_1], void 0, function* (registerPlaceReviewRequestDto, options = {}) {
            // verify required parameter 'registerPlaceReviewRequestDto' is not null or undefined
            assertParamExists('registerPlaceReviewPost', 'registerPlaceReviewRequestDto', registerPlaceReviewRequestDto);
            const localVarPath = `/registerPlaceReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerPlaceReviewRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 화장실 리뷰 정보를 등록한다.
         * @param {RegisterToiletReviewRequestDto} registerToiletReviewRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerToiletReviewPost: (registerToiletReviewRequestDto_1, ...args_1) => __awaiter(this, [registerToiletReviewRequestDto_1, ...args_1], void 0, function* (registerToiletReviewRequestDto, options = {}) {
            // verify required parameter 'registerToiletReviewRequestDto' is not null or undefined
            assertParamExists('registerToiletReviewPost', 'registerToiletReviewRequestDto', registerToiletReviewRequestDto);
            const localVarPath = `/registerToiletReview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerToiletReviewRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 윌리의 외출 NUX 튜토리얼의 첫 번째 메인 미션. 기존 값이 있더라도 전체 목록으로 덮어쓴다.
         * @summary 사용자의 관심지역과 관심테마를 등록한다.
         * @param {RegisterUserInterestedRegionsAndThemesRequestDto} registerUserInterestedRegionsAndThemesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUserInterestedRegionsAndThemes: (registerUserInterestedRegionsAndThemesRequestDto_1, ...args_1) => __awaiter(this, [registerUserInterestedRegionsAndThemesRequestDto_1, ...args_1], void 0, function* (registerUserInterestedRegionsAndThemesRequestDto, options = {}) {
            // verify required parameter 'registerUserInterestedRegionsAndThemesRequestDto' is not null or undefined
            assertParamExists('registerUserInterestedRegionsAndThemes', 'registerUserInterestedRegionsAndThemesRequestDto', registerUserInterestedRegionsAndThemesRequestDto);
            const localVarPath = `/registerUserInterestedRegionsAndThemes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(registerUserInterestedRegionsAndThemesRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 등록된 접근성 정보, 장소 리뷰, 화장실 정보 등이 올바르지 않은 경우 신고한다.
         * @param {ReportAccessibilityPostRequest} reportAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportAccessibilityPost: (reportAccessibilityPostRequest_1, ...args_1) => __awaiter(this, [reportAccessibilityPostRequest_1, ...args_1], void 0, function* (reportAccessibilityPostRequest, options = {}) {
            // verify required parameter 'reportAccessibilityPostRequest' is not null or undefined
            assertParamExists('reportAccessibilityPost', 'reportAccessibilityPostRequest', reportAccessibilityPostRequest);
            const localVarPath = `/reportAccessibility`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(reportAccessibilityPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 외부 지도앱에서 공유된 텍스트를 해석해 내부 장소로 매핑한다.
         * @param {ResolveSharedPlaceLinkRequestDto} resolveSharedPlaceLinkRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSharedPlaceLinkPost: (resolveSharedPlaceLinkRequestDto_1, ...args_1) => __awaiter(this, [resolveSharedPlaceLinkRequestDto_1, ...args_1], void 0, function* (resolveSharedPlaceLinkRequestDto, options = {}) {
            // verify required parameter 'resolveSharedPlaceLinkRequestDto' is not null or undefined
            assertParamExists('resolveSharedPlaceLinkPost', 'resolveSharedPlaceLinkRequestDto', resolveSharedPlaceLinkRequestDto);
            const localVarPath = `/resolveSharedPlaceLink`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(resolveSharedPlaceLinkRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * URL을 기준으로 SccContent를 upsert하고, 유저의 UserSavedContent를 생성한다. OG 메타데이터(title, description) + 페이지 본문 이미지(imageUrls)는 앱이 웹뷰에서 추출해 전달한다. 같은 URL로 이미 저장한 적이 있고 soft delete 상태였다면 다시 살린다.
         * @summary 웹페이지 등 컨텐츠를 저장한다.
         * @param {SaveContentRequestDto} saveContentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveContent: (saveContentRequestDto_1, ...args_1) => __awaiter(this, [saveContentRequestDto_1, ...args_1], void 0, function* (saveContentRequestDto, options = {}) {
            // verify required parameter 'saveContentRequestDto' is not null or undefined
            assertParamExists('saveContent', 'saveContentRequestDto', saveContentRequestDto);
            const localVarPath = `/saveContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(saveContentRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 장소를 내 저장 리스트에 추가한다.
         * @param {SavePlaceRequestDto} savePlaceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePlace: (savePlaceRequestDto_1, ...args_1) => __awaiter(this, [savePlaceRequestDto_1, ...args_1], void 0, function* (savePlaceRequestDto, options = {}) {
            // verify required parameter 'savePlaceRequestDto' is not null or undefined
            assertParamExists('savePlace', 'savePlaceRequestDto', savePlaceRequestDto);
            const localVarPath = `/savePlace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(savePlaceRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary PlaceList를 내 저장 목록에 추가한다.
         * @param {SavePlaceListRequestDto} savePlaceListRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePlaceList: (savePlaceListRequestDto_1, ...args_1) => __awaiter(this, [savePlaceListRequestDto_1, ...args_1], void 0, function* (savePlaceListRequestDto, options = {}) {
            // verify required parameter 'savePlaceListRequestDto' is not null or undefined
            assertParamExists('savePlaceList', 'savePlaceListRequestDto', savePlaceListRequestDto);
            const localVarPath = `/savePlaceList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(savePlaceListRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 외부 접근성 정보가 등록된 장소를 검색한다.
         * @param {SearchExternalAccessibilitiesPostRequest} searchExternalAccessibilitiesPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchExternalAccessibilitiesPost: (searchExternalAccessibilitiesPostRequest_1, ...args_1) => __awaiter(this, [searchExternalAccessibilitiesPostRequest_1, ...args_1], void 0, function* (searchExternalAccessibilitiesPostRequest, options = {}) {
            // verify required parameter 'searchExternalAccessibilitiesPostRequest' is not null or undefined
            assertParamExists('searchExternalAccessibilitiesPost', 'searchExternalAccessibilitiesPostRequest', searchExternalAccessibilitiesPostRequest);
            const localVarPath = `/searchExternalAccessibilities`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchExternalAccessibilitiesPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * ChatGPT나 Claude Desktop App처럼 자연어를 분석하여 장소를 검색한다.
         * @summary 자연어로 장소를 검색한다.
         * @param {SearchPlacesByNaturalLanguageRequestDto} searchPlacesByNaturalLanguageRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlacesByNaturalLanguagePost: (searchPlacesByNaturalLanguageRequestDto_1, ...args_1) => __awaiter(this, [searchPlacesByNaturalLanguageRequestDto_1, ...args_1], void 0, function* (searchPlacesByNaturalLanguageRequestDto, options = {}) {
            // verify required parameter 'searchPlacesByNaturalLanguageRequestDto' is not null or undefined
            assertParamExists('searchPlacesByNaturalLanguagePost', 'searchPlacesByNaturalLanguageRequestDto', searchPlacesByNaturalLanguageRequestDto);
            const localVarPath = `/searchPlacesByNaturalLanguage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchPlacesByNaturalLanguageRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 점포를 검색한다. sort 가 null 인 경우에는 정확도순을 기본으로 한다.
         * @param {SearchPlacesRequestDto} searchPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlacesPost: (searchPlacesRequestDto_1, ...args_1) => __awaiter(this, [searchPlacesRequestDto_1, ...args_1], void 0, function* (searchPlacesRequestDto, options = {}) {
            // verify required parameter 'searchPlacesRequestDto' is not null or undefined
            assertParamExists('searchPlacesPost', 'searchPlacesRequestDto', searchPlacesRequestDto);
            const localVarPath = `/searchPlaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchPlacesRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 우리 DB에 있는 장소 중 정복 안 된 장소만 검색한다. 서드파티 API를 호출하지 않고 우리 DB만 조회하므로, 정보 등록할 장소를 찾을 때 사용한다.
         * @summary 정복 안 된 장소를 검색한다.
         * @param {SearchUnconqueredPlacesNearbyRequestDto} searchUnconqueredPlacesNearbyRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUnconqueredPlacesNearbyPost: (searchUnconqueredPlacesNearbyRequestDto_1, ...args_1) => __awaiter(this, [searchUnconqueredPlacesNearbyRequestDto_1, ...args_1], void 0, function* (searchUnconqueredPlacesNearbyRequestDto, options = {}) {
            // verify required parameter 'searchUnconqueredPlacesNearbyRequestDto' is not null or undefined
            assertParamExists('searchUnconqueredPlacesNearbyPost', 'searchUnconqueredPlacesNearbyRequestDto', searchUnconqueredPlacesNearbyRequestDto);
            const localVarPath = `/searchUnconqueredPlacesNearby`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchUnconqueredPlacesNearbyRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 전화번호로 인증번호 SMS를 발송합니다. 발송된 인증번호는 3분간 유효합니다.
         * @summary 전화번호 인증 문자를 발송한다.
         * @param {SendPhoneNumberVerifCodeSmsRequestDto} sendPhoneNumberVerifCodeSmsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPhoneNumberVerifCodeSmsPost: (sendPhoneNumberVerifCodeSmsRequestDto_1, ...args_1) => __awaiter(this, [sendPhoneNumberVerifCodeSmsRequestDto_1, ...args_1], void 0, function* (sendPhoneNumberVerifCodeSmsRequestDto, options = {}) {
            // verify required parameter 'sendPhoneNumberVerifCodeSmsRequestDto' is not null or undefined
            assertParamExists('sendPhoneNumberVerifCodeSmsPost', 'sendPhoneNumberVerifCodeSmsRequestDto', sendPhoneNumberVerifCodeSmsRequestDto);
            const localVarPath = `/sendPhoneNumberVerifCodeSms`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(sendPhoneNumberVerifCodeSmsRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 회원가입을 한다.
         * @param {SignUpPostRequest} signUpPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpPost: (signUpPostRequest_1, ...args_1) => __awaiter(this, [signUpPostRequest_1, ...args_1], void 0, function* (signUpPostRequest, options = {}) {
            // verify required parameter 'signUpPostRequest' is not null or undefined
            assertParamExists('signUpPost', 'signUpPostRequest', signUpPostRequest);
            const localVarPath = `/signUp`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(signUpPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * 사용자가 입력한 prefix를 기반으로 장소 자동완성 제안을 반환한다. 선택적으로 현재 위치와 거리 제한을 전달하면 근처 장소를 우선 제안한다.
         * @summary 장소 자동완성 제안을 반환한다.
         * @param {SuggestPlacesRequestDto} suggestPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestPlacesPost: (suggestPlacesRequestDto_1, ...args_1) => __awaiter(this, [suggestPlacesRequestDto_1, ...args_1], void 0, function* (suggestPlacesRequestDto, options = {}) {
            // verify required parameter 'suggestPlacesRequestDto' is not null or undefined
            assertParamExists('suggestPlacesPost', 'suggestPlacesRequestDto', suggestPlacesRequestDto);
            const localVarPath = `/suggestPlaces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(suggestPlacesRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 컨텐츠 저장을 해제한다.
         * @param {UnsaveContentRequestDto} unsaveContentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsaveContent: (unsaveContentRequestDto_1, ...args_1) => __awaiter(this, [unsaveContentRequestDto_1, ...args_1], void 0, function* (unsaveContentRequestDto, options = {}) {
            // verify required parameter 'unsaveContentRequestDto' is not null or undefined
            assertParamExists('unsaveContent', 'unsaveContentRequestDto', unsaveContentRequestDto);
            const localVarPath = `/unsaveContent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(unsaveContentRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 장소를 내 저장 리스트에서 제거한다.
         * @param {UnsavePlaceRequestDto} unsavePlaceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsavePlace: (unsavePlaceRequestDto_1, ...args_1) => __awaiter(this, [unsavePlaceRequestDto_1, ...args_1], void 0, function* (unsavePlaceRequestDto, options = {}) {
            // verify required parameter 'unsavePlaceRequestDto' is not null or undefined
            assertParamExists('unsavePlace', 'unsavePlaceRequestDto', unsavePlaceRequestDto);
            const localVarPath = `/unsavePlace`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(unsavePlaceRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary PlaceList를 내 저장 목록에서 제거한다.
         * @param {UnsavePlaceListRequestDto} unsavePlaceListRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsavePlaceList: (unsavePlaceListRequestDto_1, ...args_1) => __awaiter(this, [unsavePlaceListRequestDto_1, ...args_1], void 0, function* (unsavePlaceListRequestDto, options = {}) {
            // verify required parameter 'unsavePlaceListRequestDto' is not null or undefined
            assertParamExists('unsavePlaceList', 'unsavePlaceListRequestDto', unsavePlaceListRequestDto);
            const localVarPath = `/unsavePlaceList`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(unsavePlaceListRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 마케팅 정보(광고성) 푸시 수신 동의 여부를 수정한다.
         * @param {UpdateMarketingPushAgreementRequestDto} updateMarketingPushAgreementRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketingPushAgreementPost: (updateMarketingPushAgreementRequestDto_1, ...args_1) => __awaiter(this, [updateMarketingPushAgreementRequestDto_1, ...args_1], void 0, function* (updateMarketingPushAgreementRequestDto, options = {}) {
            // verify required parameter 'updateMarketingPushAgreementRequestDto' is not null or undefined
            assertParamExists('updateMarketingPushAgreementPost', 'updateMarketingPushAgreementRequestDto', updateMarketingPushAgreementRequestDto);
            const localVarPath = `/updateMarketingPushAgreement`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateMarketingPushAgreementRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * sendPhoneNumberVerifCodeSms API로 발송된 인증번호와 토큰을 사용하여 전화번호를 검증하고 사용자 프로필에 저장합니다.
         * @summary 인증번호로 전화번호를 검증하고 업데이트한다.
         * @param {UpdatePhoneNumberWithVerifCodeRequestDto} updatePhoneNumberWithVerifCodeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoneNumberWithVerifCodePost: (updatePhoneNumberWithVerifCodeRequestDto_1, ...args_1) => __awaiter(this, [updatePhoneNumberWithVerifCodeRequestDto_1, ...args_1], void 0, function* (updatePhoneNumberWithVerifCodeRequestDto, options = {}) {
            // verify required parameter 'updatePhoneNumberWithVerifCodeRequestDto' is not null or undefined
            assertParamExists('updatePhoneNumberWithVerifCodePost', 'updatePhoneNumberWithVerifCodeRequestDto', updatePhoneNumberWithVerifCodeRequestDto);
            const localVarPath = `/updatePhoneNumberWithVerifCode`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updatePhoneNumberWithVerifCodeRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 유저의 push token 정보를 수정한다.
         * @param {UpdatePushTokenPostRequest} updatePushTokenPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePushTokenPost: (updatePushTokenPostRequest_1, ...args_1) => __awaiter(this, [updatePushTokenPostRequest_1, ...args_1], void 0, function* (updatePushTokenPostRequest, options = {}) {
            // verify required parameter 'updatePushTokenPostRequest' is not null or undefined
            assertParamExists('updatePushTokenPost', 'updatePushTokenPostRequest', updatePushTokenPostRequest);
            const localVarPath = `/updatePushToken`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updatePushTokenPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 유저 정보를 수정한다.
         * @param {UpdateUserInfoPostRequest} updateUserInfoPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserInfoPost: (updateUserInfoPostRequest_1, ...args_1) => __awaiter(this, [updateUserInfoPostRequest_1, ...args_1], void 0, function* (updateUserInfoPostRequest, options = {}) {
            // verify required parameter 'updateUserInfoPostRequest' is not null or undefined
            assertParamExists('updateUserInfoPost', 'updateUserInfoPostRequest', updateUserInfoPostRequest);
            const localVarPath = `/updateUserInfo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Identified required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserInfoPostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary 유저 프로필 정보의 유효성을 검사한다.
         * @param {ValidateUserProfilePostRequest} validateUserProfilePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUserProfilePost: (validateUserProfilePostRequest_1, ...args_1) => __awaiter(this, [validateUserProfilePostRequest_1, ...args_1], void 0, function* (validateUserProfilePostRequest, options = {}) {
            // verify required parameter 'validateUserProfilePostRequest' is not null or undefined
            assertParamExists('validateUserProfilePost', 'validateUserProfilePostRequest', validateUserProfilePostRequest);
            const localVarPath = `/validateUserProfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(validateUserProfilePostRequest, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary 건물에 대해 \'이 정보가 도움이 돼요\'를 취소한다.
         * @param {CancelBuildingAccessibilityUpvoteRequestDto} cancelBuildingAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelBuildingAccessibilityUpvotePost(cancelBuildingAccessibilityUpvoteRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelBuildingAccessibilityUpvotePost(cancelBuildingAccessibilityUpvoteRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 장소에 대해 \'이 정보가 도움이 돼요\'를 취소한다.
         * @param {CancelPlaceAccessibilityUpvoteRequestDto} cancelPlaceAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelPlaceAccessibilityUpvotePost(cancelPlaceAccessibilityUpvoteRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelPlaceAccessibilityUpvotePost(cancelPlaceAccessibilityUpvoteRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary \'도움이 돼요\'를 취소한다.
         * @param {CancelUpvoteRequestDto} cancelUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelUpvotePost(cancelUpvoteRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.cancelUpvotePost(cancelUpvoteRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 크러셔 클럽 퀘스트에 체크인한다.
         * @param {CheckInToClubQuestRequestDto} checkInToClubQuestRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInToClubQuestPost(checkInToClubQuestRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.checkInToClubQuestPost(checkInToClubQuestRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 튜토리얼 전용 화면에서 미션 완료 조건을 충족했을 때 앱이 호출한다. request body 의 missionType 으로 어떤 미션을 완료하려는지 식별하며, 미션별 추가 컨텍스트(예: SAVE_PLACE_LIST 의 placeListId)는 동일 body 에 함께 전달한다.  서버 검증 (미션 타입별): - VIEW_TUTORIAL_IMAGES: 추가 검증 없음 (앱이 튜토리얼 이미지 마지막 장 CTA에서 호출). - REGISTER_INTERESTED_REGIONS_AND_THEMES: 추가 검증 없음 (클라이언트가 등록 직후 호출). - SAVE_PLACE_LIST: 추가 검증 없음 (클라이언트가 저장 직후 placeListId 와 함께 호출). - UPVOTE_ACCESSIBILITY: 추가 검증 없음 (가짜 PDP 에서 사용자 명시 액션 후 호출되므로). - HIDDEN_APP_SURVEY: tally API 로 form 제출 기록 검증. 제출 기록 없으면 400.  idempotent: 이미 완료된 미션이면 no-op + 현재 진행 상태 반환.  튜토리얼 페이지를 거치지 않은 진입 (홈에서 PublicPlaceList 직접 진입 등) 에서는 앱이 이 엔드포인트를 호출하지 않으므로 미션이 완료되지 않는다. 실제 데이터 등록/저장 API (savePlaceList, registerUserInterestedRegionsAndThemes, giveAccessibilityUpvote) 는 미션 진행을 자동 기록하지 않는다.
         * @summary 윌리의 외출 NUX 튜토리얼 미션 완료를 처리한다.
         * @param {CompleteUserTutorialMissionRequestDto} completeUserTutorialMissionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeUserTutorialMission(completeUserTutorialMissionRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.completeUserTutorialMission(completeUserTutorialMissionRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 비회원 계정을 생성한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnonymousUserPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createAnonymousUserPost(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 장소의 접근성 정보를 요청한다.
         * @param {CreatePlaceAccessibilityInfoRequestRequestDto} createPlaceAccessibilityInfoRequestRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlaceAccessibilityInfoRequestPost(createPlaceAccessibilityInfoRequestRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPlaceAccessibilityInfoRequestPost(createPlaceAccessibilityInfoRequestRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * /savePlace를 사용하세요.
         * @summary 장소를 즐겨찾기에 추가한다.
         * @param {CreatePlaceFavoriteRequestDto} createPlaceFavoriteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createPlaceFavoritePost(createPlaceFavoriteRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createPlaceFavoritePost(createPlaceFavoriteRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 등록한 건물의 접근성 정보를 삭제한다.
         * @param {DeleteBuildingAccessibilityPostRequest} deleteBuildingAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBuildingAccessibilityPost(deleteBuildingAccessibilityPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteBuildingAccessibilityPost(deleteBuildingAccessibilityPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 장소의 접근성 정보 요청을 취소한다.
         * @param {DeletePlaceAccessibilityInfoRequestRequestDto} deletePlaceAccessibilityInfoRequestRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaceAccessibilityInfoRequestPost(deletePlaceAccessibilityInfoRequestRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePlaceAccessibilityInfoRequestPost(deletePlaceAccessibilityInfoRequestRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 등록한 장소의 접근성 정보를 삭제한다.
         * @param {DeletePlaceAccessibilityPostRequest} deletePlaceAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaceAccessibilityPost(deletePlaceAccessibilityPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePlaceAccessibilityPost(deletePlaceAccessibilityPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * /unsavePlace를 사용하세요.
         * @summary 장소를 즐겨찾기에서 삭제한다.
         * @param {DeletePlaceFavoriteRequestDto} deletePlaceFavoriteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deletePlaceFavoritePost(deletePlaceFavoriteRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePlaceFavoritePost(deletePlaceFavoriteRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 등록한 장소 리뷰를 삭제한다.
         * @param {DeletePlaceReviewPostRequest} deletePlaceReviewPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaceReviewPost(deletePlaceReviewPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deletePlaceReviewPost(deletePlaceReviewPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 등록한 화장실 리뷰를 삭제한다.
         * @param {DeleteToiletReviewPostRequest} deleteToiletReviewPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToiletReviewPost(deleteToiletReviewPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteToiletReviewPost(deleteToiletReviewPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 계정을 삭제한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteUserPost(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 유저 접근성 정보 정복 활동을 조회한다
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityActivityReportPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccessibilityActivityReportPost(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 현재 탑 랭커들을 조회한다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityLeaderboardPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccessibilityLeaderboardPost(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 건물 & 점포의 접근성 정보를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityPost(getAccessibilityPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccessibilityPost(getAccessibilityPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 내 현재 랭크를 조회한다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityRankPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccessibilityRankPost(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 건물 & 점포의 접근성 정보를 조회한다. (v2 - 클로즈 베타)
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityV2Post(getAccessibilityPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAccessibilityV2Post(getAccessibilityPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 검색 결과에 접근레벨 2 이하인 장소가 하나도 없을 때(부정경험 상태) 클라이언트가 지도 카드 포커스가 확정될 때마다 호출한다. 해당 장소의 vendor 세부 카테고리(예: 한식)를 대체 검색어 후보로 뽑아 실제 재검색을 시뮬레이션하고, 접근레벨 2 이하 결과가 3개를 초과할 때만 제안을 내려준다. 제안할 것이 없으면 suggestion이 null이다. 비인증 유저도 조회 가능하다.
         * @summary 포커스된 장소를 기준으로 대체 검색어를 제안할지 판단한다.
         * @param {GetAlternativeSearchSuggestionRequestDto} getAlternativeSearchSuggestionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlternativeSearchSuggestion(getAlternativeSearchSuggestionRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAlternativeSearchSuggestion(getAlternativeSearchSuggestionRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 뿌클로드 페이지 정보를 조회한다.
         * @param {GetBbucleRoadPageRequestDto} getBbucleRoadPageRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBbucleRoadPage(getBbucleRoadPageRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getBbucleRoadPage(getBbucleRoadPageRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 챌린지 리스트에서 공개된 챌린지를 선택해서 챌린지를 조회한다.
         * @param {GetChallengeRequestDto} getChallengeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengePost(getChallengeRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getChallengePost(getChallengeRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 공개되지 않은 챌린지를 초대코드를 통해 챌린지를 조회한다.
         * @param {GetChallengeWithInvitationCodeRequestDto} getChallengeWithInvitationCodeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeWithInvitationCodePost(getChallengeWithInvitationCodeRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getChallengeWithInvitationCodePost(getChallengeWithInvitationCodeRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 앱 버전에 따라 업데이트 상태를 알려준다
         * @param {GetClientVersionStatusRequestDto} getClientVersionStatusRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientVersionStatusPost(getClientVersionStatusRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getClientVersionStatusPost(getClientVersionStatusRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 다음 랭크로 올라가기 위한 점수를 조회한다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountForNextRankPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCountForNextRankPost(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 크러셔 활동 페이지를 그리기 위한 데이터를 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrusherActivityPageDataPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCrusherActivityPageDataPost(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 특정 크러셔 클럽의 활동 정보를 조회한다.
         * @param {GetCrusherActivityRequestDto} getCrusherActivityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrusherActivityPost(getCrusherActivityRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCrusherActivityPost(getCrusherActivityRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary /getCrusherActivityPage 로 대체됨
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCurrentCrusherActivityPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getCurrentCrusherActivityPost(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 공공 접근성 정보를 확인한다.
         * @param {GetExternalAccessibilityPostRequest} getExternalAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAccessibilityPost(getExternalAccessibilityPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getExternalAccessibilityPost(getExternalAccessibilityPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 홈에서 보여줄 배너 정보 목록을 가져온다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeBanners(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHomeBanners(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 홈 화면에 필요한 모든 데이터를 가져온다.
         * @param {GetHomeScreenDataRequestDto} [getHomeScreenDataRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeScreenData(getHomeScreenDataRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getHomeScreenData(getHomeScreenDataRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 점포 정보 등록 등의 상황에서 이미지를 업로드하기 위한 URL을 받아 온다.
         * @param {GetImageUploadUrlsPostRequest} getImageUploadUrlsPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageUploadUrlsPost(getImageUploadUrlsPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getImageUploadUrlsPost(getImageUploadUrlsPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 주변 정복 상태를 조회한다.
         * @param {GetNearbyAccessibilityStatusPostRequest} getNearbyAccessibilityStatusPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNearbyAccessibilityStatusPost(getNearbyAccessibilityStatusPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getNearbyAccessibilityStatusPost(getNearbyAccessibilityStatusPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary PlaceList(저장 리스트)를 조회한다.
         * @param {GetPlaceListRequestDto} getPlaceListRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaceList(getPlaceListRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPlaceList(getPlaceListRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 건물 & 점포 정보를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaceWithBuildingPost(getAccessibilityPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getPlaceWithBuildingPost(getAccessibilityPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 유저의 리뷰 등록 활동을 조회한다
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewActivityReportPost(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getReviewActivityReportPost(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * sccContentId 로 SccContent 를 조회한다. 비로그인 사용자도 호출 가능하다 (예: 공유된 컨텐츠 링크로 진입).
         * @summary SccContent 단건을 id로 조회한다.
         * @param {GetSccContentRequestDto} getSccContentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSccContent(getSccContentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSccContent(getSccContentRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 웹뷰 진입 시 라운드트립 1회로 끝낼 수 있도록 저장 상태와 좋아요 요약을 통합 응답한다. - URL 기준으로 SccContent id + 현재 유저의 저장 여부. - 서버가 URL pattern 에서 좋아요 target 을 추론하여 응답의 upvoteSummary 에 좋아요 요약(totalCount, isUpvoted) 을 채운다.   (BBUCLE_ROAD: con.staircrusher.club / staircrusherclub.notion.site 의 path id, ARTICLE: web.staircrusher.club/articles/ 이하 경로) - 좋아요 개념이 적용되지 않는 URL 이면 upvoteSummary 는 null. - 한 번도 저장된 적 없는 URL이면 sccContentId 는 null 로 응답한다.
         * @summary 웹뷰 컨텐츠의 저장 상태 + 좋아요 요약을 한 번에 조회한다.
         * @param {GetSccContentDetailsRequestDto} getSccContentDetailsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSccContentDetails(getSccContentDetailsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getSccContentDetails(getSccContentDetailsRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 도움이 되었어요를 누른 사람들과 통계를 받아온다
         * @param {GetUpvoteDetailsRequestDto} getUpvoteDetailsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpvoteDetailsPost(getUpvoteDetailsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUpvoteDetailsPost(getUpvoteDetailsRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 유저 정보를 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserInfoGet(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 로그인 사용자는 본인의 저장된 미션 진행 상태를 반환받는다. 익명 사용자도 호출 가능하며, 이 경우 모든 미션이 미완료 상태로 반환된다.
         * @summary 윌리의 외출 NUX 튜토리얼 미션 진행 상태를 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTutorialProgress(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getUserTutorialProgress(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 건물에 대해 \'이 정보가 도움이 돼요\'를 준다.
         * @param {GiveBuildingAccessibilityUpvoteRequestDto} giveBuildingAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        giveBuildingAccessibilityUpvotePost(giveBuildingAccessibilityUpvoteRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.giveBuildingAccessibilityUpvotePost(giveBuildingAccessibilityUpvoteRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 장소에 대해 \'이 정보가 도움이 돼요\'를 준다.
         * @param {GivePlaceAccessibilityUpvoteRequestDto} givePlaceAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        givePlaceAccessibilityUpvotePost(givePlaceAccessibilityUpvoteRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.givePlaceAccessibilityUpvotePost(givePlaceAccessibilityUpvoteRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary PDP AI 접근성 요약에 붐업/붐따를 남긴다. 같은 장소에 다시 호출하면 덮어쓴다.
         * @param {GivePlaceAiSummaryFeedbackRequestDto} givePlaceAiSummaryFeedbackRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        givePlaceAiSummaryFeedbackPost(givePlaceAiSummaryFeedbackRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.givePlaceAiSummaryFeedbackPost(givePlaceAiSummaryFeedbackRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary \'도움이 돼요\'를 준다.
         * @param {GiveUpvoteRequestDto} giveUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveUpvotePost(giveUpvoteRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.giveUpvotePost(giveUpvoteRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 챌린지에 참여한다.
         * @param {JoinChallengeRequestDto} joinChallengeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinChallengePost(joinChallengeRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.joinChallengePost(joinChallengeRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * challenge.hasConquerTargetPlaceList 가 true 인 챌린지에서만 호출 가능하다. 연결된 정복 대상 장소 목록이 없으면 400 을 내려준다.
         * @summary 챌린지에 연결된 정복 대상 장소 목록을 조회한다.
         * @param {ListChallengeConquerTargetPlacesRequestDto} listChallengeConquerTargetPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChallengeConquerTargetPlacesPost(listChallengeConquerTargetPlacesRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listChallengeConquerTargetPlacesPost(listChallengeConquerTargetPlacesRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 공개된 챌린지 리스트를 조회한다.
         * @param {ListChallengesRequestDto} listChallengesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChallengesPost(listChallengesRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listChallengesPost(listChallengesRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 내가 정복한 장소 목록을 조회한다.
         * @param {ListConqueredPlacesRequestDto} listConqueredPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConqueredPlacesPost(listConqueredPlacesRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listConqueredPlacesPost(listConqueredPlacesRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 윌리의 외출 NUX 튜토리얼 첫 번째 메인 미션의 관심 지역 선택 화면(Figma 1648-41115)에서 사용한다. 시도 단위로 그룹핑된 시군구 그룹 목록을 반환한다. 앱이 정적으로 들고 있지 않고 서버에서 받아오게 하여, 지역 목록을 서버에서 자유롭게 확장할 수 있도록 한다.
         * @summary 관심 지역 등록 시 사용할 시도/시군구 그룹 목록을 가져온다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterestedRegions(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listInterestedRegions(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 즐겨찾기한 장소 목록을 조회한다.
         * @param {ListPlaceFavoritesRequestDto} listPlaceFavoritesRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listPlaceFavoritesPost(listPlaceFavoritesRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPlaceFavoritesPost(listPlaceFavoritesRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 실내 리뷰를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlaceReviewsPost(getAccessibilityPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPlaceReviewsPost(getAccessibilityPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 현재 지도 중심점(currentLocation)이 추천 항목의 폴리곤 내부에 있으면 해당 추천을 반환한다. 매칭되는 추천이 없으면 빈 배열을 반환한다. 비인증 사용자도 조회 가능하다.
         * @summary 현재 지도 영역에 해당하는 장소 검색 추천 목록을 조회한다.
         * @param {ListPlaceSearchRecommendationsRequestDto} listPlaceSearchRecommendationsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlaceSearchRecommendations(listPlaceSearchRecommendationsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPlaceSearchRecommendations(listPlaceSearchRecommendationsRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * \'이 건물에 다른 점포 등록하기\'를 눌렀을 때 호출된다.
         * @summary 특정 건물의 점포를 조회한다.
         * @param {ListPlacesInBuildingPostRequest} listPlacesInBuildingPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlacesInBuildingPost(listPlacesInBuildingPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPlacesInBuildingPost(listPlacesInBuildingPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Google Drive 파일 공유 모델과 유사한 접근 제어를 따른다. - `PUBLIC` 리스트는 모든 사용자(익명 포함)에게 노출된다. - `LINK_ONLY` 리스트는 NUX 튜토리얼의 모든 메인 미션을 완료한 식별 사용자에게만 노출된다. - `PRIVATE` 리스트는 노출되지 않는다.
         * @summary 공개된 PlaceList 목록을 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPublicPlaceLists(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listPublicPlaceLists(options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 내가 작성한 내부 공간 리뷰를 페이징 해서 가져온다.
         * @param {ListRegisteredReviewsRequestDto} listRegisteredReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegisteredPlaceReviewsPost(listRegisteredReviewsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRegisteredPlaceReviewsPost(listRegisteredReviewsRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 내가 작성한 화장실 리뷰를 페이징 해서 가져온다.
         * @param {ListRegisteredReviewsRequestDto} listRegisteredReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegisteredToiletReviewsPost(listRegisteredReviewsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listRegisteredToiletReviewsPost(listRegisteredReviewsRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 저장 시각 역순(createdAt DESC)으로 페이징한다. \'저장한 장소\' 페이지의 \'저장한 컨텐츠\' 탭에서 사용한다.
         * @summary 저장한 컨텐츠 목록을 조회한다.
         * @param {ListSavedContentsRequestDto} listSavedContentsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSavedContents(listSavedContentsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSavedContents(listSavedContentsRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 내가 저장한 PlaceList 목록을 조회한다.
         * @param {ListSavedPlaceListsRequestDto} listSavedPlaceListsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSavedPlaceLists(listSavedPlaceListsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSavedPlaceLists(listSavedPlaceListsRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 음식점, 카페, 편의점, 병원 같이 키워드를 내려주면 searchPlaces 키워드로 쓸 수 있습니다.
         * @summary 특정 카테고리의 점포들을 검색할 수 있게 키워드들을 내려준다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSearchKeywordsOfPlaceCategoryPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSearchKeywordsOfPlaceCategoryPost(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 현재는 추천 키워드만 내려준다
         * @summary 특정 조건의 검색을 할 수 있는 추천 값을 내려준다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSearchPlacePresetsPost(body, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listSearchPlacePresetsPost(body, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 화장실 리뷰를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listToiletReviewsPost(getAccessibilityPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listToiletReviewsPost(getAccessibilityPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 내가 작성한 내부 공간 리뷰 중 도움이 되었어요를 받은 리뷰를 페이징 해서 가져온다.
         * @param {ListUpvotedReviewsRequestDto} listUpvotedReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpvotedPlaceReviewsPost(listUpvotedReviewsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUpvotedPlaceReviewsPost(listUpvotedReviewsRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 내가 등록한 접근성 정보(건물/장소) 중 도움이 되었어요를 받은 장소를 페이징 해서 가져온다
         * @param {ListUpvotedPlacesRequestDto} listUpvotedPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpvotedPlacesPost(listUpvotedPlacesRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUpvotedPlacesPost(listUpvotedPlacesRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 내가 작성한 화장실 리뷰 중 도움이 되었어요를 받은 리뷰를 페이징 해서 가져온다.
         * @param {ListUpvotedReviewsRequestDto} listUpvotedReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpvotedToiletReviewsPost(listUpvotedReviewsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.listUpvotedToiletReviewsPost(listUpvotedReviewsRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 로그인을 한다.
         * @param {LoginPostRequest} loginPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginPost(loginPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loginPost(loginPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 애플 로그인을 통해 로그인 or 회원가입을 한다.
         * @param {LoginWithAppleRequestDto} loginWithAppleRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithApplePost(loginWithAppleRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loginWithApplePost(loginWithAppleRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 카카오 로그인을 통해 로그인 or 회원가입을 한다.
         * @param {LoginWithKakaoPostRequest} loginWithKakaoPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithKakaoPost(loginWithKakaoPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.loginWithKakaoPost(loginWithKakaoPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 크러셔 활동을 기록한다.
         * @param {RecordCrusherClubActivityRequestDto} recordCrusherClubActivityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordCrusherClubActivityPost(recordCrusherClubActivityRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.recordCrusherClubActivityPost(recordCrusherClubActivityRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 건물에 의견을 추가한다.
         * @param {RegisterBuildingAccessibilityCommentPostRequest} registerBuildingAccessibilityCommentPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBuildingAccessibilityCommentPost(registerBuildingAccessibilityCommentPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerBuildingAccessibilityCommentPost(registerBuildingAccessibilityCommentPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 건물 접근성 정보를 등록한다.
         * @param {RegisterBuildingAccessibilityRequestDto} registerBuildingAccessibilityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBuildingAccessibilityPost(registerBuildingAccessibilityRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerBuildingAccessibilityPost(registerBuildingAccessibilityRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 건물 입구 및 엘리베이터 접근성 정보를 등록한다. (v2 - 클로즈 베타)
         * @param {RegisterBuildingAccessibilityRequestDtoV2} registerBuildingAccessibilityRequestDtoV2
         * @param {string} [xSCCREQUESTID] Optional request ID header used for tracing, logging, and idempotency. 클라이언트에서 동일한 요청을 여러 번 보내도 한 번만 처리되도록 보장합니다. 같은 X-SCC-REQUEST-ID로 요청이 오면 이전 결과를 반환합니다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBuildingAccessibilityV2Post(registerBuildingAccessibilityRequestDtoV2, xSCCREQUESTID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerBuildingAccessibilityV2Post(registerBuildingAccessibilityRequestDtoV2, xSCCREQUESTID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 사람이 검수한 접근성 정보 결과를 등록한다.
         * @param {RegisterHumanInspectionResultRequestDto} registerHumanInspectionResultRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerHumanInspectionResultPost(registerHumanInspectionResultRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerHumanInspectionResultPost(registerHumanInspectionResultRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 점포에 의견을 추가한다.
         * @param {RegisterPlaceAccessibilityCommentPostRequest} registerPlaceAccessibilityCommentPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceAccessibilityCommentPost(registerPlaceAccessibilityCommentPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerPlaceAccessibilityCommentPost(registerPlaceAccessibilityCommentPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 점포의 접근성 정보를 등록한다.
         * @param {RegisterPlaceAccessibilityRequestDto} registerPlaceAccessibilityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceAccessibilityPost(registerPlaceAccessibilityRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerPlaceAccessibilityPost(registerPlaceAccessibilityRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 장소 입구 접근성 정보를 등록한다. (v2 - 클로즈 베타)
         * @param {RegisterPlaceAccessibilityRequestDtoV2} registerPlaceAccessibilityRequestDtoV2
         * @param {string} [xSCCREQUESTID] Optional request ID header used for tracing, logging, and idempotency. 클라이언트에서 동일한 요청을 여러 번 보내도 한 번만 처리되도록 보장합니다. 같은 X-SCC-REQUEST-ID로 요청이 오면 이전 결과를 반환합니다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceAccessibilityV2Post(registerPlaceAccessibilityRequestDtoV2, xSCCREQUESTID, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerPlaceAccessibilityV2Post(registerPlaceAccessibilityRequestDtoV2, xSCCREQUESTID, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 점포의 내부 및 방문 리뷰 정보를 등록한다.
         * @param {RegisterPlaceReviewRequestDto} registerPlaceReviewRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceReviewPost(registerPlaceReviewRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerPlaceReviewPost(registerPlaceReviewRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 화장실 리뷰 정보를 등록한다.
         * @param {RegisterToiletReviewRequestDto} registerToiletReviewRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerToiletReviewPost(registerToiletReviewRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerToiletReviewPost(registerToiletReviewRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 윌리의 외출 NUX 튜토리얼의 첫 번째 메인 미션. 기존 값이 있더라도 전체 목록으로 덮어쓴다.
         * @summary 사용자의 관심지역과 관심테마를 등록한다.
         * @param {RegisterUserInterestedRegionsAndThemesRequestDto} registerUserInterestedRegionsAndThemesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUserInterestedRegionsAndThemes(registerUserInterestedRegionsAndThemesRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.registerUserInterestedRegionsAndThemes(registerUserInterestedRegionsAndThemesRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 등록된 접근성 정보, 장소 리뷰, 화장실 정보 등이 올바르지 않은 경우 신고한다.
         * @param {ReportAccessibilityPostRequest} reportAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportAccessibilityPost(reportAccessibilityPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.reportAccessibilityPost(reportAccessibilityPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 외부 지도앱에서 공유된 텍스트를 해석해 내부 장소로 매핑한다.
         * @param {ResolveSharedPlaceLinkRequestDto} resolveSharedPlaceLinkRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSharedPlaceLinkPost(resolveSharedPlaceLinkRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resolveSharedPlaceLinkPost(resolveSharedPlaceLinkRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * URL을 기준으로 SccContent를 upsert하고, 유저의 UserSavedContent를 생성한다. OG 메타데이터(title, description) + 페이지 본문 이미지(imageUrls)는 앱이 웹뷰에서 추출해 전달한다. 같은 URL로 이미 저장한 적이 있고 soft delete 상태였다면 다시 살린다.
         * @summary 웹페이지 등 컨텐츠를 저장한다.
         * @param {SaveContentRequestDto} saveContentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveContent(saveContentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.saveContent(saveContentRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 장소를 내 저장 리스트에 추가한다.
         * @param {SavePlaceRequestDto} savePlaceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePlace(savePlaceRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savePlace(savePlaceRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary PlaceList를 내 저장 목록에 추가한다.
         * @param {SavePlaceListRequestDto} savePlaceListRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePlaceList(savePlaceListRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.savePlaceList(savePlaceListRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 외부 접근성 정보가 등록된 장소를 검색한다.
         * @param {SearchExternalAccessibilitiesPostRequest} searchExternalAccessibilitiesPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchExternalAccessibilitiesPost(searchExternalAccessibilitiesPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchExternalAccessibilitiesPost(searchExternalAccessibilitiesPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * ChatGPT나 Claude Desktop App처럼 자연어를 분석하여 장소를 검색한다.
         * @summary 자연어로 장소를 검색한다.
         * @param {SearchPlacesByNaturalLanguageRequestDto} searchPlacesByNaturalLanguageRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlacesByNaturalLanguagePost(searchPlacesByNaturalLanguageRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchPlacesByNaturalLanguagePost(searchPlacesByNaturalLanguageRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 점포를 검색한다. sort 가 null 인 경우에는 정확도순을 기본으로 한다.
         * @param {SearchPlacesRequestDto} searchPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlacesPost(searchPlacesRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchPlacesPost(searchPlacesRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 우리 DB에 있는 장소 중 정복 안 된 장소만 검색한다. 서드파티 API를 호출하지 않고 우리 DB만 조회하므로, 정보 등록할 장소를 찾을 때 사용한다.
         * @summary 정복 안 된 장소를 검색한다.
         * @param {SearchUnconqueredPlacesNearbyRequestDto} searchUnconqueredPlacesNearbyRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUnconqueredPlacesNearbyPost(searchUnconqueredPlacesNearbyRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchUnconqueredPlacesNearbyPost(searchUnconqueredPlacesNearbyRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 전화번호로 인증번호 SMS를 발송합니다. 발송된 인증번호는 3분간 유효합니다.
         * @summary 전화번호 인증 문자를 발송한다.
         * @param {SendPhoneNumberVerifCodeSmsRequestDto} sendPhoneNumberVerifCodeSmsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPhoneNumberVerifCodeSmsPost(sendPhoneNumberVerifCodeSmsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.sendPhoneNumberVerifCodeSmsPost(sendPhoneNumberVerifCodeSmsRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 회원가입을 한다.
         * @param {SignUpPostRequest} signUpPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpPost(signUpPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.signUpPost(signUpPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * 사용자가 입력한 prefix를 기반으로 장소 자동완성 제안을 반환한다. 선택적으로 현재 위치와 거리 제한을 전달하면 근처 장소를 우선 제안한다.
         * @summary 장소 자동완성 제안을 반환한다.
         * @param {SuggestPlacesRequestDto} suggestPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestPlacesPost(suggestPlacesRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.suggestPlacesPost(suggestPlacesRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 컨텐츠 저장을 해제한다.
         * @param {UnsaveContentRequestDto} unsaveContentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsaveContent(unsaveContentRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unsaveContent(unsaveContentRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 장소를 내 저장 리스트에서 제거한다.
         * @param {UnsavePlaceRequestDto} unsavePlaceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsavePlace(unsavePlaceRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unsavePlace(unsavePlaceRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary PlaceList를 내 저장 목록에서 제거한다.
         * @param {UnsavePlaceListRequestDto} unsavePlaceListRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsavePlaceList(unsavePlaceListRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.unsavePlaceList(unsavePlaceListRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 마케팅 정보(광고성) 푸시 수신 동의 여부를 수정한다.
         * @param {UpdateMarketingPushAgreementRequestDto} updateMarketingPushAgreementRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketingPushAgreementPost(updateMarketingPushAgreementRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateMarketingPushAgreementPost(updateMarketingPushAgreementRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * sendPhoneNumberVerifCodeSms API로 발송된 인증번호와 토큰을 사용하여 전화번호를 검증하고 사용자 프로필에 저장합니다.
         * @summary 인증번호로 전화번호를 검증하고 업데이트한다.
         * @param {UpdatePhoneNumberWithVerifCodeRequestDto} updatePhoneNumberWithVerifCodeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoneNumberWithVerifCodePost(updatePhoneNumberWithVerifCodeRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePhoneNumberWithVerifCodePost(updatePhoneNumberWithVerifCodeRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 유저의 push token 정보를 수정한다.
         * @param {UpdatePushTokenPostRequest} updatePushTokenPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePushTokenPost(updatePushTokenPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updatePushTokenPost(updatePushTokenPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 유저 정보를 수정한다.
         * @param {UpdateUserInfoPostRequest} updateUserInfoPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserInfoPost(updateUserInfoPostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.updateUserInfoPost(updateUserInfoPostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary 유저 프로필 정보의 유효성을 검사한다.
         * @param {ValidateUserProfilePostRequest} validateUserProfilePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUserProfilePost(validateUserProfilePostRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.validateUserProfilePost(validateUserProfilePostRequest, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = DefaultApiFp(configuration);
    return {
        /**
         *
         * @summary 건물에 대해 \'이 정보가 도움이 돼요\'를 취소한다.
         * @param {CancelBuildingAccessibilityUpvoteRequestDto} cancelBuildingAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelBuildingAccessibilityUpvotePost(cancelBuildingAccessibilityUpvoteRequestDto, options) {
            return localVarFp.cancelBuildingAccessibilityUpvotePost(cancelBuildingAccessibilityUpvoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 장소에 대해 \'이 정보가 도움이 돼요\'를 취소한다.
         * @param {CancelPlaceAccessibilityUpvoteRequestDto} cancelPlaceAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        cancelPlaceAccessibilityUpvotePost(cancelPlaceAccessibilityUpvoteRequestDto, options) {
            return localVarFp.cancelPlaceAccessibilityUpvotePost(cancelPlaceAccessibilityUpvoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary \'도움이 돼요\'를 취소한다.
         * @param {CancelUpvoteRequestDto} cancelUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelUpvotePost(cancelUpvoteRequestDto, options) {
            return localVarFp.cancelUpvotePost(cancelUpvoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 크러셔 클럽 퀘스트에 체크인한다.
         * @param {CheckInToClubQuestRequestDto} checkInToClubQuestRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkInToClubQuestPost(checkInToClubQuestRequestDto, options) {
            return localVarFp.checkInToClubQuestPost(checkInToClubQuestRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 튜토리얼 전용 화면에서 미션 완료 조건을 충족했을 때 앱이 호출한다. request body 의 missionType 으로 어떤 미션을 완료하려는지 식별하며, 미션별 추가 컨텍스트(예: SAVE_PLACE_LIST 의 placeListId)는 동일 body 에 함께 전달한다.  서버 검증 (미션 타입별): - VIEW_TUTORIAL_IMAGES: 추가 검증 없음 (앱이 튜토리얼 이미지 마지막 장 CTA에서 호출). - REGISTER_INTERESTED_REGIONS_AND_THEMES: 추가 검증 없음 (클라이언트가 등록 직후 호출). - SAVE_PLACE_LIST: 추가 검증 없음 (클라이언트가 저장 직후 placeListId 와 함께 호출). - UPVOTE_ACCESSIBILITY: 추가 검증 없음 (가짜 PDP 에서 사용자 명시 액션 후 호출되므로). - HIDDEN_APP_SURVEY: tally API 로 form 제출 기록 검증. 제출 기록 없으면 400.  idempotent: 이미 완료된 미션이면 no-op + 현재 진행 상태 반환.  튜토리얼 페이지를 거치지 않은 진입 (홈에서 PublicPlaceList 직접 진입 등) 에서는 앱이 이 엔드포인트를 호출하지 않으므로 미션이 완료되지 않는다. 실제 데이터 등록/저장 API (savePlaceList, registerUserInterestedRegionsAndThemes, giveAccessibilityUpvote) 는 미션 진행을 자동 기록하지 않는다.
         * @summary 윌리의 외출 NUX 튜토리얼 미션 완료를 처리한다.
         * @param {CompleteUserTutorialMissionRequestDto} completeUserTutorialMissionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        completeUserTutorialMission(completeUserTutorialMissionRequestDto, options) {
            return localVarFp.completeUserTutorialMission(completeUserTutorialMissionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 비회원 계정을 생성한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAnonymousUserPost(options) {
            return localVarFp.createAnonymousUserPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 장소의 접근성 정보를 요청한다.
         * @param {CreatePlaceAccessibilityInfoRequestRequestDto} createPlaceAccessibilityInfoRequestRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPlaceAccessibilityInfoRequestPost(createPlaceAccessibilityInfoRequestRequestDto, options) {
            return localVarFp.createPlaceAccessibilityInfoRequestPost(createPlaceAccessibilityInfoRequestRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * /savePlace를 사용하세요.
         * @summary 장소를 즐겨찾기에 추가한다.
         * @param {CreatePlaceFavoriteRequestDto} createPlaceFavoriteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createPlaceFavoritePost(createPlaceFavoriteRequestDto, options) {
            return localVarFp.createPlaceFavoritePost(createPlaceFavoriteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 등록한 건물의 접근성 정보를 삭제한다.
         * @param {DeleteBuildingAccessibilityPostRequest} deleteBuildingAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteBuildingAccessibilityPost(deleteBuildingAccessibilityPostRequest, options) {
            return localVarFp.deleteBuildingAccessibilityPost(deleteBuildingAccessibilityPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 장소의 접근성 정보 요청을 취소한다.
         * @param {DeletePlaceAccessibilityInfoRequestRequestDto} deletePlaceAccessibilityInfoRequestRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaceAccessibilityInfoRequestPost(deletePlaceAccessibilityInfoRequestRequestDto, options) {
            return localVarFp.deletePlaceAccessibilityInfoRequestPost(deletePlaceAccessibilityInfoRequestRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 등록한 장소의 접근성 정보를 삭제한다.
         * @param {DeletePlaceAccessibilityPostRequest} deletePlaceAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaceAccessibilityPost(deletePlaceAccessibilityPostRequest, options) {
            return localVarFp.deletePlaceAccessibilityPost(deletePlaceAccessibilityPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * /unsavePlace를 사용하세요.
         * @summary 장소를 즐겨찾기에서 삭제한다.
         * @param {DeletePlaceFavoriteRequestDto} deletePlaceFavoriteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deletePlaceFavoritePost(deletePlaceFavoriteRequestDto, options) {
            return localVarFp.deletePlaceFavoritePost(deletePlaceFavoriteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 등록한 장소 리뷰를 삭제한다.
         * @param {DeletePlaceReviewPostRequest} deletePlaceReviewPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePlaceReviewPost(deletePlaceReviewPostRequest, options) {
            return localVarFp.deletePlaceReviewPost(deletePlaceReviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 등록한 화장실 리뷰를 삭제한다.
         * @param {DeleteToiletReviewPostRequest} deleteToiletReviewPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteToiletReviewPost(deleteToiletReviewPostRequest, options) {
            return localVarFp.deleteToiletReviewPost(deleteToiletReviewPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 계정을 삭제한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserPost(options) {
            return localVarFp.deleteUserPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 유저 접근성 정보 정복 활동을 조회한다
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityActivityReportPost(options) {
            return localVarFp.getAccessibilityActivityReportPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 현재 탑 랭커들을 조회한다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityLeaderboardPost(body, options) {
            return localVarFp.getAccessibilityLeaderboardPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 건물 & 점포의 접근성 정보를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityPost(getAccessibilityPostRequest, options) {
            return localVarFp.getAccessibilityPost(getAccessibilityPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 내 현재 랭크를 조회한다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityRankPost(body, options) {
            return localVarFp.getAccessibilityRankPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 건물 & 점포의 접근성 정보를 조회한다. (v2 - 클로즈 베타)
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibilityV2Post(getAccessibilityPostRequest, options) {
            return localVarFp.getAccessibilityV2Post(getAccessibilityPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 검색 결과에 접근레벨 2 이하인 장소가 하나도 없을 때(부정경험 상태) 클라이언트가 지도 카드 포커스가 확정될 때마다 호출한다. 해당 장소의 vendor 세부 카테고리(예: 한식)를 대체 검색어 후보로 뽑아 실제 재검색을 시뮬레이션하고, 접근레벨 2 이하 결과가 3개를 초과할 때만 제안을 내려준다. 제안할 것이 없으면 suggestion이 null이다. 비인증 유저도 조회 가능하다.
         * @summary 포커스된 장소를 기준으로 대체 검색어를 제안할지 판단한다.
         * @param {GetAlternativeSearchSuggestionRequestDto} getAlternativeSearchSuggestionRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlternativeSearchSuggestion(getAlternativeSearchSuggestionRequestDto, options) {
            return localVarFp.getAlternativeSearchSuggestion(getAlternativeSearchSuggestionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 뿌클로드 페이지 정보를 조회한다.
         * @param {GetBbucleRoadPageRequestDto} getBbucleRoadPageRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBbucleRoadPage(getBbucleRoadPageRequestDto, options) {
            return localVarFp.getBbucleRoadPage(getBbucleRoadPageRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 챌린지 리스트에서 공개된 챌린지를 선택해서 챌린지를 조회한다.
         * @param {GetChallengeRequestDto} getChallengeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengePost(getChallengeRequestDto, options) {
            return localVarFp.getChallengePost(getChallengeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 공개되지 않은 챌린지를 초대코드를 통해 챌린지를 조회한다.
         * @param {GetChallengeWithInvitationCodeRequestDto} getChallengeWithInvitationCodeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getChallengeWithInvitationCodePost(getChallengeWithInvitationCodeRequestDto, options) {
            return localVarFp.getChallengeWithInvitationCodePost(getChallengeWithInvitationCodeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 앱 버전에 따라 업데이트 상태를 알려준다
         * @param {GetClientVersionStatusRequestDto} getClientVersionStatusRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientVersionStatusPost(getClientVersionStatusRequestDto, options) {
            return localVarFp.getClientVersionStatusPost(getClientVersionStatusRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 다음 랭크로 올라가기 위한 점수를 조회한다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountForNextRankPost(body, options) {
            return localVarFp.getCountForNextRankPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 크러셔 활동 페이지를 그리기 위한 데이터를 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrusherActivityPageDataPost(options) {
            return localVarFp.getCrusherActivityPageDataPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 특정 크러셔 클럽의 활동 정보를 조회한다.
         * @param {GetCrusherActivityRequestDto} getCrusherActivityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCrusherActivityPost(getCrusherActivityRequestDto, options) {
            return localVarFp.getCrusherActivityPost(getCrusherActivityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary /getCrusherActivityPage 로 대체됨
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCurrentCrusherActivityPost(options) {
            return localVarFp.getCurrentCrusherActivityPost(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 공공 접근성 정보를 확인한다.
         * @param {GetExternalAccessibilityPostRequest} getExternalAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getExternalAccessibilityPost(getExternalAccessibilityPostRequest, options) {
            return localVarFp.getExternalAccessibilityPost(getExternalAccessibilityPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 홈에서 보여줄 배너 정보 목록을 가져온다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeBanners(options) {
            return localVarFp.getHomeBanners(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 홈 화면에 필요한 모든 데이터를 가져온다.
         * @param {GetHomeScreenDataRequestDto} [getHomeScreenDataRequestDto]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHomeScreenData(getHomeScreenDataRequestDto, options) {
            return localVarFp.getHomeScreenData(getHomeScreenDataRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 점포 정보 등록 등의 상황에서 이미지를 업로드하기 위한 URL을 받아 온다.
         * @param {GetImageUploadUrlsPostRequest} getImageUploadUrlsPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageUploadUrlsPost(getImageUploadUrlsPostRequest, options) {
            return localVarFp.getImageUploadUrlsPost(getImageUploadUrlsPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 주변 정복 상태를 조회한다.
         * @param {GetNearbyAccessibilityStatusPostRequest} getNearbyAccessibilityStatusPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNearbyAccessibilityStatusPost(getNearbyAccessibilityStatusPostRequest, options) {
            return localVarFp.getNearbyAccessibilityStatusPost(getNearbyAccessibilityStatusPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary PlaceList(저장 리스트)를 조회한다.
         * @param {GetPlaceListRequestDto} getPlaceListRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaceList(getPlaceListRequestDto, options) {
            return localVarFp.getPlaceList(getPlaceListRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 건물 & 점포 정보를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPlaceWithBuildingPost(getAccessibilityPostRequest, options) {
            return localVarFp.getPlaceWithBuildingPost(getAccessibilityPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 유저의 리뷰 등록 활동을 조회한다
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReviewActivityReportPost(options) {
            return localVarFp.getReviewActivityReportPost(options).then((request) => request(axios, basePath));
        },
        /**
         * sccContentId 로 SccContent 를 조회한다. 비로그인 사용자도 호출 가능하다 (예: 공유된 컨텐츠 링크로 진입).
         * @summary SccContent 단건을 id로 조회한다.
         * @param {GetSccContentRequestDto} getSccContentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSccContent(getSccContentRequestDto, options) {
            return localVarFp.getSccContent(getSccContentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 웹뷰 진입 시 라운드트립 1회로 끝낼 수 있도록 저장 상태와 좋아요 요약을 통합 응답한다. - URL 기준으로 SccContent id + 현재 유저의 저장 여부. - 서버가 URL pattern 에서 좋아요 target 을 추론하여 응답의 upvoteSummary 에 좋아요 요약(totalCount, isUpvoted) 을 채운다.   (BBUCLE_ROAD: con.staircrusher.club / staircrusherclub.notion.site 의 path id, ARTICLE: web.staircrusher.club/articles/ 이하 경로) - 좋아요 개념이 적용되지 않는 URL 이면 upvoteSummary 는 null. - 한 번도 저장된 적 없는 URL이면 sccContentId 는 null 로 응답한다.
         * @summary 웹뷰 컨텐츠의 저장 상태 + 좋아요 요약을 한 번에 조회한다.
         * @param {GetSccContentDetailsRequestDto} getSccContentDetailsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSccContentDetails(getSccContentDetailsRequestDto, options) {
            return localVarFp.getSccContentDetails(getSccContentDetailsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 도움이 되었어요를 누른 사람들과 통계를 받아온다
         * @param {GetUpvoteDetailsRequestDto} getUpvoteDetailsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUpvoteDetailsPost(getUpvoteDetailsRequestDto, options) {
            return localVarFp.getUpvoteDetailsPost(getUpvoteDetailsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 유저 정보를 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoGet(options) {
            return localVarFp.getUserInfoGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 로그인 사용자는 본인의 저장된 미션 진행 상태를 반환받는다. 익명 사용자도 호출 가능하며, 이 경우 모든 미션이 미완료 상태로 반환된다.
         * @summary 윌리의 외출 NUX 튜토리얼 미션 진행 상태를 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTutorialProgress(options) {
            return localVarFp.getUserTutorialProgress(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 건물에 대해 \'이 정보가 도움이 돼요\'를 준다.
         * @param {GiveBuildingAccessibilityUpvoteRequestDto} giveBuildingAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        giveBuildingAccessibilityUpvotePost(giveBuildingAccessibilityUpvoteRequestDto, options) {
            return localVarFp.giveBuildingAccessibilityUpvotePost(giveBuildingAccessibilityUpvoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 장소에 대해 \'이 정보가 도움이 돼요\'를 준다.
         * @param {GivePlaceAccessibilityUpvoteRequestDto} givePlaceAccessibilityUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        givePlaceAccessibilityUpvotePost(givePlaceAccessibilityUpvoteRequestDto, options) {
            return localVarFp.givePlaceAccessibilityUpvotePost(givePlaceAccessibilityUpvoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary PDP AI 접근성 요약에 붐업/붐따를 남긴다. 같은 장소에 다시 호출하면 덮어쓴다.
         * @param {GivePlaceAiSummaryFeedbackRequestDto} givePlaceAiSummaryFeedbackRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        givePlaceAiSummaryFeedbackPost(givePlaceAiSummaryFeedbackRequestDto, options) {
            return localVarFp.givePlaceAiSummaryFeedbackPost(givePlaceAiSummaryFeedbackRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary \'도움이 돼요\'를 준다.
         * @param {GiveUpvoteRequestDto} giveUpvoteRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giveUpvotePost(giveUpvoteRequestDto, options) {
            return localVarFp.giveUpvotePost(giveUpvoteRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 챌린지에 참여한다.
         * @param {JoinChallengeRequestDto} joinChallengeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        joinChallengePost(joinChallengeRequestDto, options) {
            return localVarFp.joinChallengePost(joinChallengeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * challenge.hasConquerTargetPlaceList 가 true 인 챌린지에서만 호출 가능하다. 연결된 정복 대상 장소 목록이 없으면 400 을 내려준다.
         * @summary 챌린지에 연결된 정복 대상 장소 목록을 조회한다.
         * @param {ListChallengeConquerTargetPlacesRequestDto} listChallengeConquerTargetPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChallengeConquerTargetPlacesPost(listChallengeConquerTargetPlacesRequestDto, options) {
            return localVarFp.listChallengeConquerTargetPlacesPost(listChallengeConquerTargetPlacesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 공개된 챌린지 리스트를 조회한다.
         * @param {ListChallengesRequestDto} listChallengesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listChallengesPost(listChallengesRequestDto, options) {
            return localVarFp.listChallengesPost(listChallengesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 내가 정복한 장소 목록을 조회한다.
         * @param {ListConqueredPlacesRequestDto} listConqueredPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listConqueredPlacesPost(listConqueredPlacesRequestDto, options) {
            return localVarFp.listConqueredPlacesPost(listConqueredPlacesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 윌리의 외출 NUX 튜토리얼 첫 번째 메인 미션의 관심 지역 선택 화면(Figma 1648-41115)에서 사용한다. 시도 단위로 그룹핑된 시군구 그룹 목록을 반환한다. 앱이 정적으로 들고 있지 않고 서버에서 받아오게 하여, 지역 목록을 서버에서 자유롭게 확장할 수 있도록 한다.
         * @summary 관심 지역 등록 시 사용할 시도/시군구 그룹 목록을 가져온다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInterestedRegions(options) {
            return localVarFp.listInterestedRegions(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 즐겨찾기한 장소 목록을 조회한다.
         * @param {ListPlaceFavoritesRequestDto} listPlaceFavoritesRequestDto
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        listPlaceFavoritesPost(listPlaceFavoritesRequestDto, options) {
            return localVarFp.listPlaceFavoritesPost(listPlaceFavoritesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 실내 리뷰를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlaceReviewsPost(getAccessibilityPostRequest, options) {
            return localVarFp.listPlaceReviewsPost(getAccessibilityPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 현재 지도 중심점(currentLocation)이 추천 항목의 폴리곤 내부에 있으면 해당 추천을 반환한다. 매칭되는 추천이 없으면 빈 배열을 반환한다. 비인증 사용자도 조회 가능하다.
         * @summary 현재 지도 영역에 해당하는 장소 검색 추천 목록을 조회한다.
         * @param {ListPlaceSearchRecommendationsRequestDto} listPlaceSearchRecommendationsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlaceSearchRecommendations(listPlaceSearchRecommendationsRequestDto, options) {
            return localVarFp.listPlaceSearchRecommendations(listPlaceSearchRecommendationsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * \'이 건물에 다른 점포 등록하기\'를 눌렀을 때 호출된다.
         * @summary 특정 건물의 점포를 조회한다.
         * @param {ListPlacesInBuildingPostRequest} listPlacesInBuildingPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPlacesInBuildingPost(listPlacesInBuildingPostRequest, options) {
            return localVarFp.listPlacesInBuildingPost(listPlacesInBuildingPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Google Drive 파일 공유 모델과 유사한 접근 제어를 따른다. - `PUBLIC` 리스트는 모든 사용자(익명 포함)에게 노출된다. - `LINK_ONLY` 리스트는 NUX 튜토리얼의 모든 메인 미션을 완료한 식별 사용자에게만 노출된다. - `PRIVATE` 리스트는 노출되지 않는다.
         * @summary 공개된 PlaceList 목록을 조회한다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listPublicPlaceLists(options) {
            return localVarFp.listPublicPlaceLists(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 내가 작성한 내부 공간 리뷰를 페이징 해서 가져온다.
         * @param {ListRegisteredReviewsRequestDto} listRegisteredReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegisteredPlaceReviewsPost(listRegisteredReviewsRequestDto, options) {
            return localVarFp.listRegisteredPlaceReviewsPost(listRegisteredReviewsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 내가 작성한 화장실 리뷰를 페이징 해서 가져온다.
         * @param {ListRegisteredReviewsRequestDto} listRegisteredReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRegisteredToiletReviewsPost(listRegisteredReviewsRequestDto, options) {
            return localVarFp.listRegisteredToiletReviewsPost(listRegisteredReviewsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 저장 시각 역순(createdAt DESC)으로 페이징한다. \'저장한 장소\' 페이지의 \'저장한 컨텐츠\' 탭에서 사용한다.
         * @summary 저장한 컨텐츠 목록을 조회한다.
         * @param {ListSavedContentsRequestDto} listSavedContentsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSavedContents(listSavedContentsRequestDto, options) {
            return localVarFp.listSavedContents(listSavedContentsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 내가 저장한 PlaceList 목록을 조회한다.
         * @param {ListSavedPlaceListsRequestDto} listSavedPlaceListsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSavedPlaceLists(listSavedPlaceListsRequestDto, options) {
            return localVarFp.listSavedPlaceLists(listSavedPlaceListsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 음식점, 카페, 편의점, 병원 같이 키워드를 내려주면 searchPlaces 키워드로 쓸 수 있습니다.
         * @summary 특정 카테고리의 점포들을 검색할 수 있게 키워드들을 내려준다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSearchKeywordsOfPlaceCategoryPost(body, options) {
            return localVarFp.listSearchKeywordsOfPlaceCategoryPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 현재는 추천 키워드만 내려준다
         * @summary 특정 조건의 검색을 할 수 있는 추천 값을 내려준다.
         * @param {object} body
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSearchPlacePresetsPost(body, options) {
            return localVarFp.listSearchPlacePresetsPost(body, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 화장실 리뷰를 조회한다.
         * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listToiletReviewsPost(getAccessibilityPostRequest, options) {
            return localVarFp.listToiletReviewsPost(getAccessibilityPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 내가 작성한 내부 공간 리뷰 중 도움이 되었어요를 받은 리뷰를 페이징 해서 가져온다.
         * @param {ListUpvotedReviewsRequestDto} listUpvotedReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpvotedPlaceReviewsPost(listUpvotedReviewsRequestDto, options) {
            return localVarFp.listUpvotedPlaceReviewsPost(listUpvotedReviewsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 내가 등록한 접근성 정보(건물/장소) 중 도움이 되었어요를 받은 장소를 페이징 해서 가져온다
         * @param {ListUpvotedPlacesRequestDto} listUpvotedPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpvotedPlacesPost(listUpvotedPlacesRequestDto, options) {
            return localVarFp.listUpvotedPlacesPost(listUpvotedPlacesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 내가 작성한 화장실 리뷰 중 도움이 되었어요를 받은 리뷰를 페이징 해서 가져온다.
         * @param {ListUpvotedReviewsRequestDto} listUpvotedReviewsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listUpvotedToiletReviewsPost(listUpvotedReviewsRequestDto, options) {
            return localVarFp.listUpvotedToiletReviewsPost(listUpvotedReviewsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 로그인을 한다.
         * @param {LoginPostRequest} loginPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginPost(loginPostRequest, options) {
            return localVarFp.loginPost(loginPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 애플 로그인을 통해 로그인 or 회원가입을 한다.
         * @param {LoginWithAppleRequestDto} loginWithAppleRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithApplePost(loginWithAppleRequestDto, options) {
            return localVarFp.loginWithApplePost(loginWithAppleRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 카카오 로그인을 통해 로그인 or 회원가입을 한다.
         * @param {LoginWithKakaoPostRequest} loginWithKakaoPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithKakaoPost(loginWithKakaoPostRequest, options) {
            return localVarFp.loginWithKakaoPost(loginWithKakaoPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 크러셔 활동을 기록한다.
         * @param {RecordCrusherClubActivityRequestDto} recordCrusherClubActivityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        recordCrusherClubActivityPost(recordCrusherClubActivityRequestDto, options) {
            return localVarFp.recordCrusherClubActivityPost(recordCrusherClubActivityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 건물에 의견을 추가한다.
         * @param {RegisterBuildingAccessibilityCommentPostRequest} registerBuildingAccessibilityCommentPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBuildingAccessibilityCommentPost(registerBuildingAccessibilityCommentPostRequest, options) {
            return localVarFp.registerBuildingAccessibilityCommentPost(registerBuildingAccessibilityCommentPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 건물 접근성 정보를 등록한다.
         * @param {RegisterBuildingAccessibilityRequestDto} registerBuildingAccessibilityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBuildingAccessibilityPost(registerBuildingAccessibilityRequestDto, options) {
            return localVarFp.registerBuildingAccessibilityPost(registerBuildingAccessibilityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 건물 입구 및 엘리베이터 접근성 정보를 등록한다. (v2 - 클로즈 베타)
         * @param {RegisterBuildingAccessibilityRequestDtoV2} registerBuildingAccessibilityRequestDtoV2
         * @param {string} [xSCCREQUESTID] Optional request ID header used for tracing, logging, and idempotency. 클라이언트에서 동일한 요청을 여러 번 보내도 한 번만 처리되도록 보장합니다. 같은 X-SCC-REQUEST-ID로 요청이 오면 이전 결과를 반환합니다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerBuildingAccessibilityV2Post(registerBuildingAccessibilityRequestDtoV2, xSCCREQUESTID, options) {
            return localVarFp.registerBuildingAccessibilityV2Post(registerBuildingAccessibilityRequestDtoV2, xSCCREQUESTID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 사람이 검수한 접근성 정보 결과를 등록한다.
         * @param {RegisterHumanInspectionResultRequestDto} registerHumanInspectionResultRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerHumanInspectionResultPost(registerHumanInspectionResultRequestDto, options) {
            return localVarFp.registerHumanInspectionResultPost(registerHumanInspectionResultRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 점포에 의견을 추가한다.
         * @param {RegisterPlaceAccessibilityCommentPostRequest} registerPlaceAccessibilityCommentPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceAccessibilityCommentPost(registerPlaceAccessibilityCommentPostRequest, options) {
            return localVarFp.registerPlaceAccessibilityCommentPost(registerPlaceAccessibilityCommentPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 점포의 접근성 정보를 등록한다.
         * @param {RegisterPlaceAccessibilityRequestDto} registerPlaceAccessibilityRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceAccessibilityPost(registerPlaceAccessibilityRequestDto, options) {
            return localVarFp.registerPlaceAccessibilityPost(registerPlaceAccessibilityRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 장소 입구 접근성 정보를 등록한다. (v2 - 클로즈 베타)
         * @param {RegisterPlaceAccessibilityRequestDtoV2} registerPlaceAccessibilityRequestDtoV2
         * @param {string} [xSCCREQUESTID] Optional request ID header used for tracing, logging, and idempotency. 클라이언트에서 동일한 요청을 여러 번 보내도 한 번만 처리되도록 보장합니다. 같은 X-SCC-REQUEST-ID로 요청이 오면 이전 결과를 반환합니다.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceAccessibilityV2Post(registerPlaceAccessibilityRequestDtoV2, xSCCREQUESTID, options) {
            return localVarFp.registerPlaceAccessibilityV2Post(registerPlaceAccessibilityRequestDtoV2, xSCCREQUESTID, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 점포의 내부 및 방문 리뷰 정보를 등록한다.
         * @param {RegisterPlaceReviewRequestDto} registerPlaceReviewRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerPlaceReviewPost(registerPlaceReviewRequestDto, options) {
            return localVarFp.registerPlaceReviewPost(registerPlaceReviewRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 화장실 리뷰 정보를 등록한다.
         * @param {RegisterToiletReviewRequestDto} registerToiletReviewRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerToiletReviewPost(registerToiletReviewRequestDto, options) {
            return localVarFp.registerToiletReviewPost(registerToiletReviewRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 윌리의 외출 NUX 튜토리얼의 첫 번째 메인 미션. 기존 값이 있더라도 전체 목록으로 덮어쓴다.
         * @summary 사용자의 관심지역과 관심테마를 등록한다.
         * @param {RegisterUserInterestedRegionsAndThemesRequestDto} registerUserInterestedRegionsAndThemesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerUserInterestedRegionsAndThemes(registerUserInterestedRegionsAndThemesRequestDto, options) {
            return localVarFp.registerUserInterestedRegionsAndThemes(registerUserInterestedRegionsAndThemesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 등록된 접근성 정보, 장소 리뷰, 화장실 정보 등이 올바르지 않은 경우 신고한다.
         * @param {ReportAccessibilityPostRequest} reportAccessibilityPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportAccessibilityPost(reportAccessibilityPostRequest, options) {
            return localVarFp.reportAccessibilityPost(reportAccessibilityPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 외부 지도앱에서 공유된 텍스트를 해석해 내부 장소로 매핑한다.
         * @param {ResolveSharedPlaceLinkRequestDto} resolveSharedPlaceLinkRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resolveSharedPlaceLinkPost(resolveSharedPlaceLinkRequestDto, options) {
            return localVarFp.resolveSharedPlaceLinkPost(resolveSharedPlaceLinkRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * URL을 기준으로 SccContent를 upsert하고, 유저의 UserSavedContent를 생성한다. OG 메타데이터(title, description) + 페이지 본문 이미지(imageUrls)는 앱이 웹뷰에서 추출해 전달한다. 같은 URL로 이미 저장한 적이 있고 soft delete 상태였다면 다시 살린다.
         * @summary 웹페이지 등 컨텐츠를 저장한다.
         * @param {SaveContentRequestDto} saveContentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveContent(saveContentRequestDto, options) {
            return localVarFp.saveContent(saveContentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 장소를 내 저장 리스트에 추가한다.
         * @param {SavePlaceRequestDto} savePlaceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePlace(savePlaceRequestDto, options) {
            return localVarFp.savePlace(savePlaceRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary PlaceList를 내 저장 목록에 추가한다.
         * @param {SavePlaceListRequestDto} savePlaceListRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePlaceList(savePlaceListRequestDto, options) {
            return localVarFp.savePlaceList(savePlaceListRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 외부 접근성 정보가 등록된 장소를 검색한다.
         * @param {SearchExternalAccessibilitiesPostRequest} searchExternalAccessibilitiesPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchExternalAccessibilitiesPost(searchExternalAccessibilitiesPostRequest, options) {
            return localVarFp.searchExternalAccessibilitiesPost(searchExternalAccessibilitiesPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ChatGPT나 Claude Desktop App처럼 자연어를 분석하여 장소를 검색한다.
         * @summary 자연어로 장소를 검색한다.
         * @param {SearchPlacesByNaturalLanguageRequestDto} searchPlacesByNaturalLanguageRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlacesByNaturalLanguagePost(searchPlacesByNaturalLanguageRequestDto, options) {
            return localVarFp.searchPlacesByNaturalLanguagePost(searchPlacesByNaturalLanguageRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 점포를 검색한다. sort 가 null 인 경우에는 정확도순을 기본으로 한다.
         * @param {SearchPlacesRequestDto} searchPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchPlacesPost(searchPlacesRequestDto, options) {
            return localVarFp.searchPlacesPost(searchPlacesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 우리 DB에 있는 장소 중 정복 안 된 장소만 검색한다. 서드파티 API를 호출하지 않고 우리 DB만 조회하므로, 정보 등록할 장소를 찾을 때 사용한다.
         * @summary 정복 안 된 장소를 검색한다.
         * @param {SearchUnconqueredPlacesNearbyRequestDto} searchUnconqueredPlacesNearbyRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUnconqueredPlacesNearbyPost(searchUnconqueredPlacesNearbyRequestDto, options) {
            return localVarFp.searchUnconqueredPlacesNearbyPost(searchUnconqueredPlacesNearbyRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 전화번호로 인증번호 SMS를 발송합니다. 발송된 인증번호는 3분간 유효합니다.
         * @summary 전화번호 인증 문자를 발송한다.
         * @param {SendPhoneNumberVerifCodeSmsRequestDto} sendPhoneNumberVerifCodeSmsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendPhoneNumberVerifCodeSmsPost(sendPhoneNumberVerifCodeSmsRequestDto, options) {
            return localVarFp.sendPhoneNumberVerifCodeSmsPost(sendPhoneNumberVerifCodeSmsRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 회원가입을 한다.
         * @param {SignUpPostRequest} signUpPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signUpPost(signUpPostRequest, options) {
            return localVarFp.signUpPost(signUpPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 사용자가 입력한 prefix를 기반으로 장소 자동완성 제안을 반환한다. 선택적으로 현재 위치와 거리 제한을 전달하면 근처 장소를 우선 제안한다.
         * @summary 장소 자동완성 제안을 반환한다.
         * @param {SuggestPlacesRequestDto} suggestPlacesRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        suggestPlacesPost(suggestPlacesRequestDto, options) {
            return localVarFp.suggestPlacesPost(suggestPlacesRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 컨텐츠 저장을 해제한다.
         * @param {UnsaveContentRequestDto} unsaveContentRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsaveContent(unsaveContentRequestDto, options) {
            return localVarFp.unsaveContent(unsaveContentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 장소를 내 저장 리스트에서 제거한다.
         * @param {UnsavePlaceRequestDto} unsavePlaceRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsavePlace(unsavePlaceRequestDto, options) {
            return localVarFp.unsavePlace(unsavePlaceRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary PlaceList를 내 저장 목록에서 제거한다.
         * @param {UnsavePlaceListRequestDto} unsavePlaceListRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsavePlaceList(unsavePlaceListRequestDto, options) {
            return localVarFp.unsavePlaceList(unsavePlaceListRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 마케팅 정보(광고성) 푸시 수신 동의 여부를 수정한다.
         * @param {UpdateMarketingPushAgreementRequestDto} updateMarketingPushAgreementRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMarketingPushAgreementPost(updateMarketingPushAgreementRequestDto, options) {
            return localVarFp.updateMarketingPushAgreementPost(updateMarketingPushAgreementRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * sendPhoneNumberVerifCodeSms API로 발송된 인증번호와 토큰을 사용하여 전화번호를 검증하고 사용자 프로필에 저장합니다.
         * @summary 인증번호로 전화번호를 검증하고 업데이트한다.
         * @param {UpdatePhoneNumberWithVerifCodeRequestDto} updatePhoneNumberWithVerifCodeRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePhoneNumberWithVerifCodePost(updatePhoneNumberWithVerifCodeRequestDto, options) {
            return localVarFp.updatePhoneNumberWithVerifCodePost(updatePhoneNumberWithVerifCodeRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 유저의 push token 정보를 수정한다.
         * @param {UpdatePushTokenPostRequest} updatePushTokenPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePushTokenPost(updatePushTokenPostRequest, options) {
            return localVarFp.updatePushTokenPost(updatePushTokenPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 유저 정보를 수정한다.
         * @param {UpdateUserInfoPostRequest} updateUserInfoPostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserInfoPost(updateUserInfoPostRequest, options) {
            return localVarFp.updateUserInfoPost(updateUserInfoPostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary 유저 프로필 정보의 유효성을 검사한다.
         * @param {ValidateUserProfilePostRequest} validateUserProfilePostRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateUserProfilePost(validateUserProfilePostRequest, options) {
            return localVarFp.validateUserProfilePost(validateUserProfilePostRequest, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     *
     * @summary 건물에 대해 \'이 정보가 도움이 돼요\'를 취소한다.
     * @param {CancelBuildingAccessibilityUpvoteRequestDto} cancelBuildingAccessibilityUpvoteRequestDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    cancelBuildingAccessibilityUpvotePost(cancelBuildingAccessibilityUpvoteRequestDto, options) {
        return DefaultApiFp(this.configuration).cancelBuildingAccessibilityUpvotePost(cancelBuildingAccessibilityUpvoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 장소에 대해 \'이 정보가 도움이 돼요\'를 취소한다.
     * @param {CancelPlaceAccessibilityUpvoteRequestDto} cancelPlaceAccessibilityUpvoteRequestDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    cancelPlaceAccessibilityUpvotePost(cancelPlaceAccessibilityUpvoteRequestDto, options) {
        return DefaultApiFp(this.configuration).cancelPlaceAccessibilityUpvotePost(cancelPlaceAccessibilityUpvoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary \'도움이 돼요\'를 취소한다.
     * @param {CancelUpvoteRequestDto} cancelUpvoteRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    cancelUpvotePost(cancelUpvoteRequestDto, options) {
        return DefaultApiFp(this.configuration).cancelUpvotePost(cancelUpvoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 크러셔 클럽 퀘스트에 체크인한다.
     * @param {CheckInToClubQuestRequestDto} checkInToClubQuestRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    checkInToClubQuestPost(checkInToClubQuestRequestDto, options) {
        return DefaultApiFp(this.configuration).checkInToClubQuestPost(checkInToClubQuestRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 튜토리얼 전용 화면에서 미션 완료 조건을 충족했을 때 앱이 호출한다. request body 의 missionType 으로 어떤 미션을 완료하려는지 식별하며, 미션별 추가 컨텍스트(예: SAVE_PLACE_LIST 의 placeListId)는 동일 body 에 함께 전달한다.  서버 검증 (미션 타입별): - VIEW_TUTORIAL_IMAGES: 추가 검증 없음 (앱이 튜토리얼 이미지 마지막 장 CTA에서 호출). - REGISTER_INTERESTED_REGIONS_AND_THEMES: 추가 검증 없음 (클라이언트가 등록 직후 호출). - SAVE_PLACE_LIST: 추가 검증 없음 (클라이언트가 저장 직후 placeListId 와 함께 호출). - UPVOTE_ACCESSIBILITY: 추가 검증 없음 (가짜 PDP 에서 사용자 명시 액션 후 호출되므로). - HIDDEN_APP_SURVEY: tally API 로 form 제출 기록 검증. 제출 기록 없으면 400.  idempotent: 이미 완료된 미션이면 no-op + 현재 진행 상태 반환.  튜토리얼 페이지를 거치지 않은 진입 (홈에서 PublicPlaceList 직접 진입 등) 에서는 앱이 이 엔드포인트를 호출하지 않으므로 미션이 완료되지 않는다. 실제 데이터 등록/저장 API (savePlaceList, registerUserInterestedRegionsAndThemes, giveAccessibilityUpvote) 는 미션 진행을 자동 기록하지 않는다.
     * @summary 윌리의 외출 NUX 튜토리얼 미션 완료를 처리한다.
     * @param {CompleteUserTutorialMissionRequestDto} completeUserTutorialMissionRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    completeUserTutorialMission(completeUserTutorialMissionRequestDto, options) {
        return DefaultApiFp(this.configuration).completeUserTutorialMission(completeUserTutorialMissionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 비회원 계정을 생성한다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createAnonymousUserPost(options) {
        return DefaultApiFp(this.configuration).createAnonymousUserPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 장소의 접근성 정보를 요청한다.
     * @param {CreatePlaceAccessibilityInfoRequestRequestDto} createPlaceAccessibilityInfoRequestRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createPlaceAccessibilityInfoRequestPost(createPlaceAccessibilityInfoRequestRequestDto, options) {
        return DefaultApiFp(this.configuration).createPlaceAccessibilityInfoRequestPost(createPlaceAccessibilityInfoRequestRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * /savePlace를 사용하세요.
     * @summary 장소를 즐겨찾기에 추가한다.
     * @param {CreatePlaceFavoriteRequestDto} createPlaceFavoriteRequestDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    createPlaceFavoritePost(createPlaceFavoriteRequestDto, options) {
        return DefaultApiFp(this.configuration).createPlaceFavoritePost(createPlaceFavoriteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 등록한 건물의 접근성 정보를 삭제한다.
     * @param {DeleteBuildingAccessibilityPostRequest} deleteBuildingAccessibilityPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteBuildingAccessibilityPost(deleteBuildingAccessibilityPostRequest, options) {
        return DefaultApiFp(this.configuration).deleteBuildingAccessibilityPost(deleteBuildingAccessibilityPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 장소의 접근성 정보 요청을 취소한다.
     * @param {DeletePlaceAccessibilityInfoRequestRequestDto} deletePlaceAccessibilityInfoRequestRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deletePlaceAccessibilityInfoRequestPost(deletePlaceAccessibilityInfoRequestRequestDto, options) {
        return DefaultApiFp(this.configuration).deletePlaceAccessibilityInfoRequestPost(deletePlaceAccessibilityInfoRequestRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 등록한 장소의 접근성 정보를 삭제한다.
     * @param {DeletePlaceAccessibilityPostRequest} deletePlaceAccessibilityPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deletePlaceAccessibilityPost(deletePlaceAccessibilityPostRequest, options) {
        return DefaultApiFp(this.configuration).deletePlaceAccessibilityPost(deletePlaceAccessibilityPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * /unsavePlace를 사용하세요.
     * @summary 장소를 즐겨찾기에서 삭제한다.
     * @param {DeletePlaceFavoriteRequestDto} deletePlaceFavoriteRequestDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deletePlaceFavoritePost(deletePlaceFavoriteRequestDto, options) {
        return DefaultApiFp(this.configuration).deletePlaceFavoritePost(deletePlaceFavoriteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 등록한 장소 리뷰를 삭제한다.
     * @param {DeletePlaceReviewPostRequest} deletePlaceReviewPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deletePlaceReviewPost(deletePlaceReviewPostRequest, options) {
        return DefaultApiFp(this.configuration).deletePlaceReviewPost(deletePlaceReviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 등록한 화장실 리뷰를 삭제한다.
     * @param {DeleteToiletReviewPostRequest} deleteToiletReviewPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteToiletReviewPost(deleteToiletReviewPostRequest, options) {
        return DefaultApiFp(this.configuration).deleteToiletReviewPost(deleteToiletReviewPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 계정을 삭제한다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    deleteUserPost(options) {
        return DefaultApiFp(this.configuration).deleteUserPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 유저 접근성 정보 정복 활동을 조회한다
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAccessibilityActivityReportPost(options) {
        return DefaultApiFp(this.configuration).getAccessibilityActivityReportPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 현재 탑 랭커들을 조회한다.
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAccessibilityLeaderboardPost(body, options) {
        return DefaultApiFp(this.configuration).getAccessibilityLeaderboardPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 건물 & 점포의 접근성 정보를 조회한다.
     * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAccessibilityPost(getAccessibilityPostRequest, options) {
        return DefaultApiFp(this.configuration).getAccessibilityPost(getAccessibilityPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 내 현재 랭크를 조회한다.
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAccessibilityRankPost(body, options) {
        return DefaultApiFp(this.configuration).getAccessibilityRankPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 건물 & 점포의 접근성 정보를 조회한다. (v2 - 클로즈 베타)
     * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAccessibilityV2Post(getAccessibilityPostRequest, options) {
        return DefaultApiFp(this.configuration).getAccessibilityV2Post(getAccessibilityPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 검색 결과에 접근레벨 2 이하인 장소가 하나도 없을 때(부정경험 상태) 클라이언트가 지도 카드 포커스가 확정될 때마다 호출한다. 해당 장소의 vendor 세부 카테고리(예: 한식)를 대체 검색어 후보로 뽑아 실제 재검색을 시뮬레이션하고, 접근레벨 2 이하 결과가 3개를 초과할 때만 제안을 내려준다. 제안할 것이 없으면 suggestion이 null이다. 비인증 유저도 조회 가능하다.
     * @summary 포커스된 장소를 기준으로 대체 검색어를 제안할지 판단한다.
     * @param {GetAlternativeSearchSuggestionRequestDto} getAlternativeSearchSuggestionRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getAlternativeSearchSuggestion(getAlternativeSearchSuggestionRequestDto, options) {
        return DefaultApiFp(this.configuration).getAlternativeSearchSuggestion(getAlternativeSearchSuggestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 뿌클로드 페이지 정보를 조회한다.
     * @param {GetBbucleRoadPageRequestDto} getBbucleRoadPageRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getBbucleRoadPage(getBbucleRoadPageRequestDto, options) {
        return DefaultApiFp(this.configuration).getBbucleRoadPage(getBbucleRoadPageRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 챌린지 리스트에서 공개된 챌린지를 선택해서 챌린지를 조회한다.
     * @param {GetChallengeRequestDto} getChallengeRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getChallengePost(getChallengeRequestDto, options) {
        return DefaultApiFp(this.configuration).getChallengePost(getChallengeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 공개되지 않은 챌린지를 초대코드를 통해 챌린지를 조회한다.
     * @param {GetChallengeWithInvitationCodeRequestDto} getChallengeWithInvitationCodeRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getChallengeWithInvitationCodePost(getChallengeWithInvitationCodeRequestDto, options) {
        return DefaultApiFp(this.configuration).getChallengeWithInvitationCodePost(getChallengeWithInvitationCodeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 앱 버전에 따라 업데이트 상태를 알려준다
     * @param {GetClientVersionStatusRequestDto} getClientVersionStatusRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getClientVersionStatusPost(getClientVersionStatusRequestDto, options) {
        return DefaultApiFp(this.configuration).getClientVersionStatusPost(getClientVersionStatusRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 다음 랭크로 올라가기 위한 점수를 조회한다.
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCountForNextRankPost(body, options) {
        return DefaultApiFp(this.configuration).getCountForNextRankPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 크러셔 활동 페이지를 그리기 위한 데이터를 조회한다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCrusherActivityPageDataPost(options) {
        return DefaultApiFp(this.configuration).getCrusherActivityPageDataPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 특정 크러셔 클럽의 활동 정보를 조회한다.
     * @param {GetCrusherActivityRequestDto} getCrusherActivityRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCrusherActivityPost(getCrusherActivityRequestDto, options) {
        return DefaultApiFp(this.configuration).getCrusherActivityPost(getCrusherActivityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary /getCrusherActivityPage 로 대체됨
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getCurrentCrusherActivityPost(options) {
        return DefaultApiFp(this.configuration).getCurrentCrusherActivityPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 공공 접근성 정보를 확인한다.
     * @param {GetExternalAccessibilityPostRequest} getExternalAccessibilityPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getExternalAccessibilityPost(getExternalAccessibilityPostRequest, options) {
        return DefaultApiFp(this.configuration).getExternalAccessibilityPost(getExternalAccessibilityPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 홈에서 보여줄 배너 정보 목록을 가져온다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getHomeBanners(options) {
        return DefaultApiFp(this.configuration).getHomeBanners(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 홈 화면에 필요한 모든 데이터를 가져온다.
     * @param {GetHomeScreenDataRequestDto} [getHomeScreenDataRequestDto]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getHomeScreenData(getHomeScreenDataRequestDto, options) {
        return DefaultApiFp(this.configuration).getHomeScreenData(getHomeScreenDataRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 점포 정보 등록 등의 상황에서 이미지를 업로드하기 위한 URL을 받아 온다.
     * @param {GetImageUploadUrlsPostRequest} getImageUploadUrlsPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getImageUploadUrlsPost(getImageUploadUrlsPostRequest, options) {
        return DefaultApiFp(this.configuration).getImageUploadUrlsPost(getImageUploadUrlsPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 주변 정복 상태를 조회한다.
     * @param {GetNearbyAccessibilityStatusPostRequest} getNearbyAccessibilityStatusPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getNearbyAccessibilityStatusPost(getNearbyAccessibilityStatusPostRequest, options) {
        return DefaultApiFp(this.configuration).getNearbyAccessibilityStatusPost(getNearbyAccessibilityStatusPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary PlaceList(저장 리스트)를 조회한다.
     * @param {GetPlaceListRequestDto} getPlaceListRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPlaceList(getPlaceListRequestDto, options) {
        return DefaultApiFp(this.configuration).getPlaceList(getPlaceListRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 건물 & 점포 정보를 조회한다.
     * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getPlaceWithBuildingPost(getAccessibilityPostRequest, options) {
        return DefaultApiFp(this.configuration).getPlaceWithBuildingPost(getAccessibilityPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 유저의 리뷰 등록 활동을 조회한다
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getReviewActivityReportPost(options) {
        return DefaultApiFp(this.configuration).getReviewActivityReportPost(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * sccContentId 로 SccContent 를 조회한다. 비로그인 사용자도 호출 가능하다 (예: 공유된 컨텐츠 링크로 진입).
     * @summary SccContent 단건을 id로 조회한다.
     * @param {GetSccContentRequestDto} getSccContentRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSccContent(getSccContentRequestDto, options) {
        return DefaultApiFp(this.configuration).getSccContent(getSccContentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 웹뷰 진입 시 라운드트립 1회로 끝낼 수 있도록 저장 상태와 좋아요 요약을 통합 응답한다. - URL 기준으로 SccContent id + 현재 유저의 저장 여부. - 서버가 URL pattern 에서 좋아요 target 을 추론하여 응답의 upvoteSummary 에 좋아요 요약(totalCount, isUpvoted) 을 채운다.   (BBUCLE_ROAD: con.staircrusher.club / staircrusherclub.notion.site 의 path id, ARTICLE: web.staircrusher.club/articles/ 이하 경로) - 좋아요 개념이 적용되지 않는 URL 이면 upvoteSummary 는 null. - 한 번도 저장된 적 없는 URL이면 sccContentId 는 null 로 응답한다.
     * @summary 웹뷰 컨텐츠의 저장 상태 + 좋아요 요약을 한 번에 조회한다.
     * @param {GetSccContentDetailsRequestDto} getSccContentDetailsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getSccContentDetails(getSccContentDetailsRequestDto, options) {
        return DefaultApiFp(this.configuration).getSccContentDetails(getSccContentDetailsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 도움이 되었어요를 누른 사람들과 통계를 받아온다
     * @param {GetUpvoteDetailsRequestDto} getUpvoteDetailsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUpvoteDetailsPost(getUpvoteDetailsRequestDto, options) {
        return DefaultApiFp(this.configuration).getUpvoteDetailsPost(getUpvoteDetailsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 유저 정보를 조회한다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUserInfoGet(options) {
        return DefaultApiFp(this.configuration).getUserInfoGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 로그인 사용자는 본인의 저장된 미션 진행 상태를 반환받는다. 익명 사용자도 호출 가능하며, 이 경우 모든 미션이 미완료 상태로 반환된다.
     * @summary 윌리의 외출 NUX 튜토리얼 미션 진행 상태를 조회한다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    getUserTutorialProgress(options) {
        return DefaultApiFp(this.configuration).getUserTutorialProgress(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 건물에 대해 \'이 정보가 도움이 돼요\'를 준다.
     * @param {GiveBuildingAccessibilityUpvoteRequestDto} giveBuildingAccessibilityUpvoteRequestDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    giveBuildingAccessibilityUpvotePost(giveBuildingAccessibilityUpvoteRequestDto, options) {
        return DefaultApiFp(this.configuration).giveBuildingAccessibilityUpvotePost(giveBuildingAccessibilityUpvoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 장소에 대해 \'이 정보가 도움이 돼요\'를 준다.
     * @param {GivePlaceAccessibilityUpvoteRequestDto} givePlaceAccessibilityUpvoteRequestDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    givePlaceAccessibilityUpvotePost(givePlaceAccessibilityUpvoteRequestDto, options) {
        return DefaultApiFp(this.configuration).givePlaceAccessibilityUpvotePost(givePlaceAccessibilityUpvoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary PDP AI 접근성 요약에 붐업/붐따를 남긴다. 같은 장소에 다시 호출하면 덮어쓴다.
     * @param {GivePlaceAiSummaryFeedbackRequestDto} givePlaceAiSummaryFeedbackRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    givePlaceAiSummaryFeedbackPost(givePlaceAiSummaryFeedbackRequestDto, options) {
        return DefaultApiFp(this.configuration).givePlaceAiSummaryFeedbackPost(givePlaceAiSummaryFeedbackRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary \'도움이 돼요\'를 준다.
     * @param {GiveUpvoteRequestDto} giveUpvoteRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    giveUpvotePost(giveUpvoteRequestDto, options) {
        return DefaultApiFp(this.configuration).giveUpvotePost(giveUpvoteRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 챌린지에 참여한다.
     * @param {JoinChallengeRequestDto} joinChallengeRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    joinChallengePost(joinChallengeRequestDto, options) {
        return DefaultApiFp(this.configuration).joinChallengePost(joinChallengeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * challenge.hasConquerTargetPlaceList 가 true 인 챌린지에서만 호출 가능하다. 연결된 정복 대상 장소 목록이 없으면 400 을 내려준다.
     * @summary 챌린지에 연결된 정복 대상 장소 목록을 조회한다.
     * @param {ListChallengeConquerTargetPlacesRequestDto} listChallengeConquerTargetPlacesRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listChallengeConquerTargetPlacesPost(listChallengeConquerTargetPlacesRequestDto, options) {
        return DefaultApiFp(this.configuration).listChallengeConquerTargetPlacesPost(listChallengeConquerTargetPlacesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 공개된 챌린지 리스트를 조회한다.
     * @param {ListChallengesRequestDto} listChallengesRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listChallengesPost(listChallengesRequestDto, options) {
        return DefaultApiFp(this.configuration).listChallengesPost(listChallengesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 내가 정복한 장소 목록을 조회한다.
     * @param {ListConqueredPlacesRequestDto} listConqueredPlacesRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listConqueredPlacesPost(listConqueredPlacesRequestDto, options) {
        return DefaultApiFp(this.configuration).listConqueredPlacesPost(listConqueredPlacesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 윌리의 외출 NUX 튜토리얼 첫 번째 메인 미션의 관심 지역 선택 화면(Figma 1648-41115)에서 사용한다. 시도 단위로 그룹핑된 시군구 그룹 목록을 반환한다. 앱이 정적으로 들고 있지 않고 서버에서 받아오게 하여, 지역 목록을 서버에서 자유롭게 확장할 수 있도록 한다.
     * @summary 관심 지역 등록 시 사용할 시도/시군구 그룹 목록을 가져온다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listInterestedRegions(options) {
        return DefaultApiFp(this.configuration).listInterestedRegions(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 즐겨찾기한 장소 목록을 조회한다.
     * @param {ListPlaceFavoritesRequestDto} listPlaceFavoritesRequestDto
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listPlaceFavoritesPost(listPlaceFavoritesRequestDto, options) {
        return DefaultApiFp(this.configuration).listPlaceFavoritesPost(listPlaceFavoritesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 실내 리뷰를 조회한다.
     * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listPlaceReviewsPost(getAccessibilityPostRequest, options) {
        return DefaultApiFp(this.configuration).listPlaceReviewsPost(getAccessibilityPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 현재 지도 중심점(currentLocation)이 추천 항목의 폴리곤 내부에 있으면 해당 추천을 반환한다. 매칭되는 추천이 없으면 빈 배열을 반환한다. 비인증 사용자도 조회 가능하다.
     * @summary 현재 지도 영역에 해당하는 장소 검색 추천 목록을 조회한다.
     * @param {ListPlaceSearchRecommendationsRequestDto} listPlaceSearchRecommendationsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listPlaceSearchRecommendations(listPlaceSearchRecommendationsRequestDto, options) {
        return DefaultApiFp(this.configuration).listPlaceSearchRecommendations(listPlaceSearchRecommendationsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * \'이 건물에 다른 점포 등록하기\'를 눌렀을 때 호출된다.
     * @summary 특정 건물의 점포를 조회한다.
     * @param {ListPlacesInBuildingPostRequest} listPlacesInBuildingPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listPlacesInBuildingPost(listPlacesInBuildingPostRequest, options) {
        return DefaultApiFp(this.configuration).listPlacesInBuildingPost(listPlacesInBuildingPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Google Drive 파일 공유 모델과 유사한 접근 제어를 따른다. - `PUBLIC` 리스트는 모든 사용자(익명 포함)에게 노출된다. - `LINK_ONLY` 리스트는 NUX 튜토리얼의 모든 메인 미션을 완료한 식별 사용자에게만 노출된다. - `PRIVATE` 리스트는 노출되지 않는다.
     * @summary 공개된 PlaceList 목록을 조회한다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listPublicPlaceLists(options) {
        return DefaultApiFp(this.configuration).listPublicPlaceLists(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 내가 작성한 내부 공간 리뷰를 페이징 해서 가져온다.
     * @param {ListRegisteredReviewsRequestDto} listRegisteredReviewsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listRegisteredPlaceReviewsPost(listRegisteredReviewsRequestDto, options) {
        return DefaultApiFp(this.configuration).listRegisteredPlaceReviewsPost(listRegisteredReviewsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 내가 작성한 화장실 리뷰를 페이징 해서 가져온다.
     * @param {ListRegisteredReviewsRequestDto} listRegisteredReviewsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listRegisteredToiletReviewsPost(listRegisteredReviewsRequestDto, options) {
        return DefaultApiFp(this.configuration).listRegisteredToiletReviewsPost(listRegisteredReviewsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 저장 시각 역순(createdAt DESC)으로 페이징한다. \'저장한 장소\' 페이지의 \'저장한 컨텐츠\' 탭에서 사용한다.
     * @summary 저장한 컨텐츠 목록을 조회한다.
     * @param {ListSavedContentsRequestDto} listSavedContentsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listSavedContents(listSavedContentsRequestDto, options) {
        return DefaultApiFp(this.configuration).listSavedContents(listSavedContentsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 내가 저장한 PlaceList 목록을 조회한다.
     * @param {ListSavedPlaceListsRequestDto} listSavedPlaceListsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listSavedPlaceLists(listSavedPlaceListsRequestDto, options) {
        return DefaultApiFp(this.configuration).listSavedPlaceLists(listSavedPlaceListsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 음식점, 카페, 편의점, 병원 같이 키워드를 내려주면 searchPlaces 키워드로 쓸 수 있습니다.
     * @summary 특정 카테고리의 점포들을 검색할 수 있게 키워드들을 내려준다.
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listSearchKeywordsOfPlaceCategoryPost(body, options) {
        return DefaultApiFp(this.configuration).listSearchKeywordsOfPlaceCategoryPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 현재는 추천 키워드만 내려준다
     * @summary 특정 조건의 검색을 할 수 있는 추천 값을 내려준다.
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listSearchPlacePresetsPost(body, options) {
        return DefaultApiFp(this.configuration).listSearchPlacePresetsPost(body, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 화장실 리뷰를 조회한다.
     * @param {GetAccessibilityPostRequest} getAccessibilityPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listToiletReviewsPost(getAccessibilityPostRequest, options) {
        return DefaultApiFp(this.configuration).listToiletReviewsPost(getAccessibilityPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 내가 작성한 내부 공간 리뷰 중 도움이 되었어요를 받은 리뷰를 페이징 해서 가져온다.
     * @param {ListUpvotedReviewsRequestDto} listUpvotedReviewsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listUpvotedPlaceReviewsPost(listUpvotedReviewsRequestDto, options) {
        return DefaultApiFp(this.configuration).listUpvotedPlaceReviewsPost(listUpvotedReviewsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 내가 등록한 접근성 정보(건물/장소) 중 도움이 되었어요를 받은 장소를 페이징 해서 가져온다
     * @param {ListUpvotedPlacesRequestDto} listUpvotedPlacesRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listUpvotedPlacesPost(listUpvotedPlacesRequestDto, options) {
        return DefaultApiFp(this.configuration).listUpvotedPlacesPost(listUpvotedPlacesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 내가 작성한 화장실 리뷰 중 도움이 되었어요를 받은 리뷰를 페이징 해서 가져온다.
     * @param {ListUpvotedReviewsRequestDto} listUpvotedReviewsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    listUpvotedToiletReviewsPost(listUpvotedReviewsRequestDto, options) {
        return DefaultApiFp(this.configuration).listUpvotedToiletReviewsPost(listUpvotedReviewsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 로그인을 한다.
     * @param {LoginPostRequest} loginPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    loginPost(loginPostRequest, options) {
        return DefaultApiFp(this.configuration).loginPost(loginPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 애플 로그인을 통해 로그인 or 회원가입을 한다.
     * @param {LoginWithAppleRequestDto} loginWithAppleRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    loginWithApplePost(loginWithAppleRequestDto, options) {
        return DefaultApiFp(this.configuration).loginWithApplePost(loginWithAppleRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 카카오 로그인을 통해 로그인 or 회원가입을 한다.
     * @param {LoginWithKakaoPostRequest} loginWithKakaoPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    loginWithKakaoPost(loginWithKakaoPostRequest, options) {
        return DefaultApiFp(this.configuration).loginWithKakaoPost(loginWithKakaoPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 크러셔 활동을 기록한다.
     * @param {RecordCrusherClubActivityRequestDto} recordCrusherClubActivityRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    recordCrusherClubActivityPost(recordCrusherClubActivityRequestDto, options) {
        return DefaultApiFp(this.configuration).recordCrusherClubActivityPost(recordCrusherClubActivityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 건물에 의견을 추가한다.
     * @param {RegisterBuildingAccessibilityCommentPostRequest} registerBuildingAccessibilityCommentPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    registerBuildingAccessibilityCommentPost(registerBuildingAccessibilityCommentPostRequest, options) {
        return DefaultApiFp(this.configuration).registerBuildingAccessibilityCommentPost(registerBuildingAccessibilityCommentPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 건물 접근성 정보를 등록한다.
     * @param {RegisterBuildingAccessibilityRequestDto} registerBuildingAccessibilityRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    registerBuildingAccessibilityPost(registerBuildingAccessibilityRequestDto, options) {
        return DefaultApiFp(this.configuration).registerBuildingAccessibilityPost(registerBuildingAccessibilityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 건물 입구 및 엘리베이터 접근성 정보를 등록한다. (v2 - 클로즈 베타)
     * @param {RegisterBuildingAccessibilityRequestDtoV2} registerBuildingAccessibilityRequestDtoV2
     * @param {string} [xSCCREQUESTID] Optional request ID header used for tracing, logging, and idempotency. 클라이언트에서 동일한 요청을 여러 번 보내도 한 번만 처리되도록 보장합니다. 같은 X-SCC-REQUEST-ID로 요청이 오면 이전 결과를 반환합니다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    registerBuildingAccessibilityV2Post(registerBuildingAccessibilityRequestDtoV2, xSCCREQUESTID, options) {
        return DefaultApiFp(this.configuration).registerBuildingAccessibilityV2Post(registerBuildingAccessibilityRequestDtoV2, xSCCREQUESTID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 사람이 검수한 접근성 정보 결과를 등록한다.
     * @param {RegisterHumanInspectionResultRequestDto} registerHumanInspectionResultRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    registerHumanInspectionResultPost(registerHumanInspectionResultRequestDto, options) {
        return DefaultApiFp(this.configuration).registerHumanInspectionResultPost(registerHumanInspectionResultRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 점포에 의견을 추가한다.
     * @param {RegisterPlaceAccessibilityCommentPostRequest} registerPlaceAccessibilityCommentPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    registerPlaceAccessibilityCommentPost(registerPlaceAccessibilityCommentPostRequest, options) {
        return DefaultApiFp(this.configuration).registerPlaceAccessibilityCommentPost(registerPlaceAccessibilityCommentPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 점포의 접근성 정보를 등록한다.
     * @param {RegisterPlaceAccessibilityRequestDto} registerPlaceAccessibilityRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    registerPlaceAccessibilityPost(registerPlaceAccessibilityRequestDto, options) {
        return DefaultApiFp(this.configuration).registerPlaceAccessibilityPost(registerPlaceAccessibilityRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 장소 입구 접근성 정보를 등록한다. (v2 - 클로즈 베타)
     * @param {RegisterPlaceAccessibilityRequestDtoV2} registerPlaceAccessibilityRequestDtoV2
     * @param {string} [xSCCREQUESTID] Optional request ID header used for tracing, logging, and idempotency. 클라이언트에서 동일한 요청을 여러 번 보내도 한 번만 처리되도록 보장합니다. 같은 X-SCC-REQUEST-ID로 요청이 오면 이전 결과를 반환합니다.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    registerPlaceAccessibilityV2Post(registerPlaceAccessibilityRequestDtoV2, xSCCREQUESTID, options) {
        return DefaultApiFp(this.configuration).registerPlaceAccessibilityV2Post(registerPlaceAccessibilityRequestDtoV2, xSCCREQUESTID, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 점포의 내부 및 방문 리뷰 정보를 등록한다.
     * @param {RegisterPlaceReviewRequestDto} registerPlaceReviewRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    registerPlaceReviewPost(registerPlaceReviewRequestDto, options) {
        return DefaultApiFp(this.configuration).registerPlaceReviewPost(registerPlaceReviewRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 화장실 리뷰 정보를 등록한다.
     * @param {RegisterToiletReviewRequestDto} registerToiletReviewRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    registerToiletReviewPost(registerToiletReviewRequestDto, options) {
        return DefaultApiFp(this.configuration).registerToiletReviewPost(registerToiletReviewRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 윌리의 외출 NUX 튜토리얼의 첫 번째 메인 미션. 기존 값이 있더라도 전체 목록으로 덮어쓴다.
     * @summary 사용자의 관심지역과 관심테마를 등록한다.
     * @param {RegisterUserInterestedRegionsAndThemesRequestDto} registerUserInterestedRegionsAndThemesRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    registerUserInterestedRegionsAndThemes(registerUserInterestedRegionsAndThemesRequestDto, options) {
        return DefaultApiFp(this.configuration).registerUserInterestedRegionsAndThemes(registerUserInterestedRegionsAndThemesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 등록된 접근성 정보, 장소 리뷰, 화장실 정보 등이 올바르지 않은 경우 신고한다.
     * @param {ReportAccessibilityPostRequest} reportAccessibilityPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    reportAccessibilityPost(reportAccessibilityPostRequest, options) {
        return DefaultApiFp(this.configuration).reportAccessibilityPost(reportAccessibilityPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 외부 지도앱에서 공유된 텍스트를 해석해 내부 장소로 매핑한다.
     * @param {ResolveSharedPlaceLinkRequestDto} resolveSharedPlaceLinkRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    resolveSharedPlaceLinkPost(resolveSharedPlaceLinkRequestDto, options) {
        return DefaultApiFp(this.configuration).resolveSharedPlaceLinkPost(resolveSharedPlaceLinkRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * URL을 기준으로 SccContent를 upsert하고, 유저의 UserSavedContent를 생성한다. OG 메타데이터(title, description) + 페이지 본문 이미지(imageUrls)는 앱이 웹뷰에서 추출해 전달한다. 같은 URL로 이미 저장한 적이 있고 soft delete 상태였다면 다시 살린다.
     * @summary 웹페이지 등 컨텐츠를 저장한다.
     * @param {SaveContentRequestDto} saveContentRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    saveContent(saveContentRequestDto, options) {
        return DefaultApiFp(this.configuration).saveContent(saveContentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 장소를 내 저장 리스트에 추가한다.
     * @param {SavePlaceRequestDto} savePlaceRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    savePlace(savePlaceRequestDto, options) {
        return DefaultApiFp(this.configuration).savePlace(savePlaceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary PlaceList를 내 저장 목록에 추가한다.
     * @param {SavePlaceListRequestDto} savePlaceListRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    savePlaceList(savePlaceListRequestDto, options) {
        return DefaultApiFp(this.configuration).savePlaceList(savePlaceListRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 외부 접근성 정보가 등록된 장소를 검색한다.
     * @param {SearchExternalAccessibilitiesPostRequest} searchExternalAccessibilitiesPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    searchExternalAccessibilitiesPost(searchExternalAccessibilitiesPostRequest, options) {
        return DefaultApiFp(this.configuration).searchExternalAccessibilitiesPost(searchExternalAccessibilitiesPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * ChatGPT나 Claude Desktop App처럼 자연어를 분석하여 장소를 검색한다.
     * @summary 자연어로 장소를 검색한다.
     * @param {SearchPlacesByNaturalLanguageRequestDto} searchPlacesByNaturalLanguageRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    searchPlacesByNaturalLanguagePost(searchPlacesByNaturalLanguageRequestDto, options) {
        return DefaultApiFp(this.configuration).searchPlacesByNaturalLanguagePost(searchPlacesByNaturalLanguageRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 점포를 검색한다. sort 가 null 인 경우에는 정확도순을 기본으로 한다.
     * @param {SearchPlacesRequestDto} searchPlacesRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    searchPlacesPost(searchPlacesRequestDto, options) {
        return DefaultApiFp(this.configuration).searchPlacesPost(searchPlacesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 우리 DB에 있는 장소 중 정복 안 된 장소만 검색한다. 서드파티 API를 호출하지 않고 우리 DB만 조회하므로, 정보 등록할 장소를 찾을 때 사용한다.
     * @summary 정복 안 된 장소를 검색한다.
     * @param {SearchUnconqueredPlacesNearbyRequestDto} searchUnconqueredPlacesNearbyRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    searchUnconqueredPlacesNearbyPost(searchUnconqueredPlacesNearbyRequestDto, options) {
        return DefaultApiFp(this.configuration).searchUnconqueredPlacesNearbyPost(searchUnconqueredPlacesNearbyRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 전화번호로 인증번호 SMS를 발송합니다. 발송된 인증번호는 3분간 유효합니다.
     * @summary 전화번호 인증 문자를 발송한다.
     * @param {SendPhoneNumberVerifCodeSmsRequestDto} sendPhoneNumberVerifCodeSmsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    sendPhoneNumberVerifCodeSmsPost(sendPhoneNumberVerifCodeSmsRequestDto, options) {
        return DefaultApiFp(this.configuration).sendPhoneNumberVerifCodeSmsPost(sendPhoneNumberVerifCodeSmsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 회원가입을 한다.
     * @param {SignUpPostRequest} signUpPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    signUpPost(signUpPostRequest, options) {
        return DefaultApiFp(this.configuration).signUpPost(signUpPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * 사용자가 입력한 prefix를 기반으로 장소 자동완성 제안을 반환한다. 선택적으로 현재 위치와 거리 제한을 전달하면 근처 장소를 우선 제안한다.
     * @summary 장소 자동완성 제안을 반환한다.
     * @param {SuggestPlacesRequestDto} suggestPlacesRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    suggestPlacesPost(suggestPlacesRequestDto, options) {
        return DefaultApiFp(this.configuration).suggestPlacesPost(suggestPlacesRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 컨텐츠 저장을 해제한다.
     * @param {UnsaveContentRequestDto} unsaveContentRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    unsaveContent(unsaveContentRequestDto, options) {
        return DefaultApiFp(this.configuration).unsaveContent(unsaveContentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 장소를 내 저장 리스트에서 제거한다.
     * @param {UnsavePlaceRequestDto} unsavePlaceRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    unsavePlace(unsavePlaceRequestDto, options) {
        return DefaultApiFp(this.configuration).unsavePlace(unsavePlaceRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary PlaceList를 내 저장 목록에서 제거한다.
     * @param {UnsavePlaceListRequestDto} unsavePlaceListRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    unsavePlaceList(unsavePlaceListRequestDto, options) {
        return DefaultApiFp(this.configuration).unsavePlaceList(unsavePlaceListRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 마케팅 정보(광고성) 푸시 수신 동의 여부를 수정한다.
     * @param {UpdateMarketingPushAgreementRequestDto} updateMarketingPushAgreementRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateMarketingPushAgreementPost(updateMarketingPushAgreementRequestDto, options) {
        return DefaultApiFp(this.configuration).updateMarketingPushAgreementPost(updateMarketingPushAgreementRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * sendPhoneNumberVerifCodeSms API로 발송된 인증번호와 토큰을 사용하여 전화번호를 검증하고 사용자 프로필에 저장합니다.
     * @summary 인증번호로 전화번호를 검증하고 업데이트한다.
     * @param {UpdatePhoneNumberWithVerifCodeRequestDto} updatePhoneNumberWithVerifCodeRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updatePhoneNumberWithVerifCodePost(updatePhoneNumberWithVerifCodeRequestDto, options) {
        return DefaultApiFp(this.configuration).updatePhoneNumberWithVerifCodePost(updatePhoneNumberWithVerifCodeRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 유저의 push token 정보를 수정한다.
     * @param {UpdatePushTokenPostRequest} updatePushTokenPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updatePushTokenPost(updatePushTokenPostRequest, options) {
        return DefaultApiFp(this.configuration).updatePushTokenPost(updatePushTokenPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 유저 정보를 수정한다.
     * @param {UpdateUserInfoPostRequest} updateUserInfoPostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    updateUserInfoPost(updateUserInfoPostRequest, options) {
        return DefaultApiFp(this.configuration).updateUserInfoPost(updateUserInfoPostRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary 유저 프로필 정보의 유효성을 검사한다.
     * @param {ValidateUserProfilePostRequest} validateUserProfilePostRequest
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    validateUserProfilePost(validateUserProfilePostRequest, options) {
        return DefaultApiFp(this.configuration).validateUserProfilePost(validateUserProfilePostRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
/**
 * ToiletApi - axios parameter creator
 * @export
 */
export const ToiletApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Toilet과 그에 병합된 모든 소스(ToiletReview/ExternalAccessibility)를 조합해 상세 정보를 내려준다.
         * @summary 화장실 상세 정보를 조회한다.
         * @param {GetToiletRequestDto} getToiletRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToilet: (getToiletRequestDto_1, ...args_1) => __awaiter(this, [getToiletRequestDto_1, ...args_1], void 0, function* (getToiletRequestDto, options = {}) {
            // verify required parameter 'getToiletRequestDto' is not null or undefined
            assertParamExists('getToilet', 'getToiletRequestDto', getToiletRequestDto);
            const localVarPath = `/getToilet`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(getToiletRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * isSearchable=true 인 Toilet을 위치 기반 nearest-N으로 반환한다. 하나의 Toilet은 공공데이터(ExternalAccessibility)와 유저 등록(ToiletReview) 소스가 병합된 통합 화장실이다.
         * @summary 화장실을 위치 기반으로 검색한다.
         * @param {SearchToiletsRequestDto} searchToiletsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchToilets: (searchToiletsRequestDto_1, ...args_1) => __awaiter(this, [searchToiletsRequestDto_1, ...args_1], void 0, function* (searchToiletsRequestDto, options = {}) {
            // verify required parameter 'searchToiletsRequestDto' is not null or undefined
            assertParamExists('searchToilets', 'searchToiletsRequestDto', searchToiletsRequestDto);
            const localVarPath = `/searchToilets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Anonymous required
            // http bearer authentication required
            yield setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(searchToiletsRequestDto, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ToiletApi - functional programming interface
 * @export
 */
export const ToiletApiFp = function (configuration) {
    const localVarAxiosParamCreator = ToiletApiAxiosParamCreator(configuration);
    return {
        /**
         * Toilet과 그에 병합된 모든 소스(ToiletReview/ExternalAccessibility)를 조합해 상세 정보를 내려준다.
         * @summary 화장실 상세 정보를 조회한다.
         * @param {GetToiletRequestDto} getToiletRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToilet(getToiletRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getToilet(getToiletRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * isSearchable=true 인 Toilet을 위치 기반 nearest-N으로 반환한다. 하나의 Toilet은 공공데이터(ExternalAccessibility)와 유저 등록(ToiletReview) 소스가 병합된 통합 화장실이다.
         * @summary 화장실을 위치 기반으로 검색한다.
         * @param {SearchToiletsRequestDto} searchToiletsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchToilets(searchToiletsRequestDto, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.searchToilets(searchToiletsRequestDto, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ToiletApi - factory interface
 * @export
 */
export const ToiletApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ToiletApiFp(configuration);
    return {
        /**
         * Toilet과 그에 병합된 모든 소스(ToiletReview/ExternalAccessibility)를 조합해 상세 정보를 내려준다.
         * @summary 화장실 상세 정보를 조회한다.
         * @param {GetToiletRequestDto} getToiletRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToilet(getToiletRequestDto, options) {
            return localVarFp.getToilet(getToiletRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * isSearchable=true 인 Toilet을 위치 기반 nearest-N으로 반환한다. 하나의 Toilet은 공공데이터(ExternalAccessibility)와 유저 등록(ToiletReview) 소스가 병합된 통합 화장실이다.
         * @summary 화장실을 위치 기반으로 검색한다.
         * @param {SearchToiletsRequestDto} searchToiletsRequestDto
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchToilets(searchToiletsRequestDto, options) {
            return localVarFp.searchToilets(searchToiletsRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ToiletApi - object-oriented interface
 * @export
 * @class ToiletApi
 * @extends {BaseAPI}
 */
export class ToiletApi extends BaseAPI {
    /**
     * Toilet과 그에 병합된 모든 소스(ToiletReview/ExternalAccessibility)를 조합해 상세 정보를 내려준다.
     * @summary 화장실 상세 정보를 조회한다.
     * @param {GetToiletRequestDto} getToiletRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToiletApi
     */
    getToilet(getToiletRequestDto, options) {
        return ToiletApiFp(this.configuration).getToilet(getToiletRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * isSearchable=true 인 Toilet을 위치 기반 nearest-N으로 반환한다. 하나의 Toilet은 공공데이터(ExternalAccessibility)와 유저 등록(ToiletReview) 소스가 병합된 통합 화장실이다.
     * @summary 화장실을 위치 기반으로 검색한다.
     * @param {SearchToiletsRequestDto} searchToiletsRequestDto
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ToiletApi
     */
    searchToilets(searchToiletsRequestDto, options) {
        return ToiletApiFp(this.configuration).searchToilets(searchToiletsRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}
